import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: any;
  /** The built-in `Decimal` scalar type. */
  Decimal: any;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: any;
  /** The name scalar represents a valid GraphQL name as specified in the spec and can be used to refer to fields or types. */
  Name: any;
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: any;
};






export type AdminCompany = {
  __typename?: 'AdminCompany';
  owners?: Maybe<Array<Maybe<CompanyOwner>>>;
  restaurants?: Maybe<Array<Maybe<Restaurant>>>;
  employeeGroups?: Maybe<Array<Maybe<CompanyEmployeeGroup>>>;
  deliveryLocations?: Maybe<Array<Maybe<CompanyDeliveryLocation>>>;
  id: Scalars['Long'];
  details?: Maybe<Array<Maybe<CompanyDetails>>>;
};

export type AdminCompanyInput = {
  owners?: Maybe<Array<Maybe<CompanyOwnerInput>>>;
  restaurants?: Maybe<Array<Maybe<RestaurantInput>>>;
  employeeGroups?: Maybe<Array<Maybe<CompanyEmployeeGroupInput>>>;
  deliveryLocations?: Maybe<Array<Maybe<CompanyDeliveryLocationInput>>>;
  id: Scalars['Long'];
  details?: Maybe<Array<Maybe<CompanyDetailsInput>>>;
};

export type AdminCompanyOwner = {
  __typename?: 'AdminCompanyOwner';
  authId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  username?: Maybe<Scalars['String']>;
};

export type AdminCompanyOwnerInput = {
  authId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  username?: Maybe<Scalars['String']>;
};

export type AdminDeliveryLocation = {
  __typename?: 'AdminDeliveryLocation';
  id: Scalars['Long'];
  companyId?: Maybe<Scalars['Long']>;
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  details?: Maybe<Array<Maybe<DeliveryLocationDetails>>>;
  timeSlots?: Maybe<Array<Maybe<AdminDeliveryLocationTimeSlot>>>;
};

export type AdminDeliveryLocationInput = {
  id: Scalars['Long'];
  companyId?: Maybe<Scalars['Long']>;
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  details?: Maybe<Array<Maybe<DeliveryLocationDetailsInput>>>;
  timeSlots?: Maybe<Array<Maybe<AdminDeliveryLocationTimeSlotInput>>>;
};

export type AdminDeliveryLocationTimeSlot = {
  __typename?: 'AdminDeliveryLocationTimeSlot';
  timeDurationBeforeOrderPlacement: Scalars['TimeSpan'];
  timeDurationBeforeOrderPlacementHour: Scalars['Int'];
  timeDurationBeforeOrderPlacementMinute: Scalars['Int'];
  timeDurationBeforeOrderToCancel: Scalars['TimeSpan'];
  timeDurationBeforeOrderToCancelHour: Scalars['Int'];
  timeDurationBeforeOrderToCancelMinute: Scalars['Int'];
  companyDeliveryLocationId?: Maybe<Scalars['Long']>;
  id: Scalars['Long'];
  time: Scalars['TimeSpan'];
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type AdminDeliveryLocationTimeSlotInput = {
  timeDurationBeforeOrderPlacement: Scalars['TimeSpan'];
  timeDurationBeforeOrderPlacementHour: Scalars['Int'];
  timeDurationBeforeOrderPlacementMinute: Scalars['Int'];
  timeDurationBeforeOrderToCancel: Scalars['TimeSpan'];
  timeDurationBeforeOrderToCancelHour: Scalars['Int'];
  timeDurationBeforeOrderToCancelMinute: Scalars['Int'];
  companyDeliveryLocationId?: Maybe<Scalars['Long']>;
  id: Scalars['Long'];
  time: Scalars['TimeSpan'];
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type AdminRestaurant = {
  __typename?: 'AdminRestaurant';
  companies?: Maybe<Array<Maybe<Company>>>;
  owners?: Maybe<Array<Maybe<RestaurantOwner>>>;
  deliveryLocations?: Maybe<Array<Maybe<DeliveryLocation>>>;
  settings?: Maybe<RestaurantSettingsAdmin>;
  commisionDetails?: Maybe<Array<Maybe<RestaurantCommisionDetails>>>;
  id: Scalars['Long'];
  currency?: Maybe<Currency>;
  details?: Maybe<Array<Maybe<RestaurantDetails>>>;
  stats?: Maybe<RestaurantsStats>;
};

export type AdminRestaurantOwner = {
  __typename?: 'AdminRestaurantOwner';
  authId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  username?: Maybe<Scalars['String']>;
};

export type AdminRestaurantOwnerInput = {
  authId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  username?: Maybe<Scalars['String']>;
};

export type AppMutation = {
  __typename?: 'AppMutation';
  createOrder?: Maybe<EmployeeOrder>;
  cancelOrder: Scalars['Boolean'];
  rateOrder: Scalars['Boolean'];
  makeComplaint: Scalars['Boolean'];
  contextData: Array<KeyValuePairOfStringAndObject>;
  scope?: Maybe<Scalars['String']>;
  name: Scalars['Name'];
  description?: Maybe<Scalars['String']>;
  createRestaurant?: Maybe<SuperAdminRestaurant>;
  updateRestaurant?: Maybe<SuperAdminRestaurant>;
  addCompanyToRestaurant: Scalars['Boolean'];
  removeCompanyFromRestaurant: Scalars['Boolean'];
  createRestaurantCompanyTimeslot?: Maybe<AdminDeliveryLocationTimeSlot>;
  editRestaurantCompanyTimeslot?: Maybe<AdminDeliveryLocationTimeSlot>;
  deleteRestaurantCompanyTimeslot: Scalars['Boolean'];
  createCompany?: Maybe<AdminCompany>;
  deleteRestaurant: Scalars['Boolean'];
  createRestaurantOwner?: Maybe<AdminRestaurantOwner>;
  updateRestaurantOwner?: Maybe<AdminRestaurantOwner>;
  deleteRestaurantOwner: Scalars['Boolean'];
  updateCompany?: Maybe<AdminCompany>;
  deleteCompany: Scalars['Boolean'];
  createCompanyOwner?: Maybe<AdminCompanyOwner>;
  updateCompanyOwner?: Maybe<AdminCompanyOwner>;
  deleteCompanyOwner: Scalars['Boolean'];
  createDeliveryLocation?: Maybe<CompanyDeliveryLocation>;
  updateDeliveryLocation?: Maybe<CompanyDeliveryLocation>;
  deleteDeliveryLocation: Scalars['Boolean'];
  changePasswordByAdmin: Scalars['Boolean'];
  createUserByAdmin?: Maybe<LunchAppUser>;
  createSubsidies: Scalars['Boolean'];
  assignSubsidies: Scalars['Boolean'];
  createMenuCategory?: Maybe<RestaurantMenuCategory>;
  createDishAllergen?: Maybe<DishAllergene>;
  deleteDishAllergen: Scalars['Boolean'];
  updateMenuCategory?: Maybe<RestaurantMenuCategory>;
  updateDishAllergen?: Maybe<DishAllergene>;
  deleteMenuCategory: Scalars['Boolean'];
  consumePasswordResetToken: Scalars['Boolean'];
  createEmployeeBatch?: Maybe<CreateEmployeeResult>;
  changePassword: Scalars['Boolean'];
  setDevicePushToken: Scalars['Boolean'];
  createUser?: Maybe<LunchAppUser>;
  createEmployeeUser?: Maybe<LunchAppUser>;
  updateUser?: Maybe<LunchAppUserEntity>;
  deleteUser: Scalars['Boolean'];
  createEmployee?: Maybe<CompanyEmployee>;
  createEmployeesFromExcel?: Maybe<Scalars['String']>;
  resetEmployeePassword: Scalars['Boolean'];
  updateEmployee?: Maybe<CompanyEmployee>;
  deleteEmployee: Scalars['Boolean'];
  createEmployeeGroup?: Maybe<CompanyEmployeeGroup>;
  updateEmployeeGroup?: Maybe<CompanyEmployeeGroup>;
  deleteEmployeeGroup: Scalars['Boolean'];
  addRestaurantDetails?: Maybe<RestaurantDetails>;
  deleteRestaurantDetails: Scalars['Boolean'];
  updateRestaurantDetails: Scalars['Boolean'];
  addDishTemplate?: Maybe<RestaurantDishTemplate>;
  updateDishTemplate?: Maybe<RestaurantDishTemplate>;
  deleteDishTemplate: Scalars['Boolean'];
  addRestaurantMenu?: Maybe<RestaurantMenu>;
  addRestaurantMenuEntry?: Maybe<RestaurantMenuEntry>;
  updateRestaurantMenuEntry?: Maybe<RestaurantMenuEntry>;
  deleteRestaurantMenuEntry: Scalars['Boolean'];
  copyLastWeekMenu: Scalars['Boolean'];
  copySelectedWeekMenu: Scalars['Boolean'];
  toggleHideRestaurantMenuEntry: Scalars['Boolean'];
  toggleAcceptedRestaurantMenuEntry: Scalars['Boolean'];
};


export type AppMutationCreateOrderArgs = {
  createOrderData?: Maybe<CreateOrderDataInput>;
};


export type AppMutationCancelOrderArgs = {
  orderId: Scalars['Int'];
};


export type AppMutationRateOrderArgs = {
  orderId: Scalars['Int'];
  ratingPoints: Scalars['Decimal'];
  ratingText?: Maybe<Scalars['String']>;
};


export type AppMutationMakeComplaintArgs = {
  orderId: Scalars['Int'];
  complaintType: Scalars['Int'];
  complaintText?: Maybe<Scalars['String']>;
};


export type AppMutationCreateRestaurantArgs = {
  restaurant?: Maybe<SuperAdminRestaurantInput>;
};


export type AppMutationUpdateRestaurantArgs = {
  restaurant?: Maybe<SuperAdminRestaurantInput>;
};


export type AppMutationAddCompanyToRestaurantArgs = {
  restaurantId: Scalars['Long'];
  companyId: Scalars['Long'];
};


export type AppMutationRemoveCompanyFromRestaurantArgs = {
  restaurantId: Scalars['Long'];
  companyId: Scalars['Long'];
};


export type AppMutationCreateRestaurantCompanyTimeslotArgs = {
  deliveryLocationTimeSlot?: Maybe<AdminDeliveryLocationTimeSlotInput>;
  companyDeliveryLocationId: Scalars['Long'];
  restaurantId: Scalars['Long'];
};


export type AppMutationEditRestaurantCompanyTimeslotArgs = {
  deliveryLocationTimeSlot?: Maybe<AdminDeliveryLocationTimeSlotInput>;
};


export type AppMutationDeleteRestaurantCompanyTimeslotArgs = {
  timeslotId: Scalars['Long'];
};


export type AppMutationCreateCompanyArgs = {
  company?: Maybe<AdminCompanyInput>;
};


export type AppMutationDeleteRestaurantArgs = {
  restaurantId: Scalars['Long'];
};


export type AppMutationCreateRestaurantOwnerArgs = {
  restaurantOwner?: Maybe<AdminRestaurantOwnerInput>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
  restaurantId: Scalars['Long'];
};


export type AppMutationUpdateRestaurantOwnerArgs = {
  restaurantOwner?: Maybe<AdminRestaurantOwnerInput>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
};


export type AppMutationDeleteRestaurantOwnerArgs = {
  ownerId: Scalars['Long'];
};


export type AppMutationUpdateCompanyArgs = {
  company?: Maybe<AdminCompanyInput>;
};


export type AppMutationDeleteCompanyArgs = {
  companyId: Scalars['Long'];
};


export type AppMutationCreateCompanyOwnerArgs = {
  companyOwner?: Maybe<AdminCompanyOwnerInput>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
  companyId: Scalars['Long'];
};


export type AppMutationUpdateCompanyOwnerArgs = {
  companyOwner?: Maybe<AdminCompanyOwnerInput>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
};


export type AppMutationDeleteCompanyOwnerArgs = {
  ownerId: Scalars['Long'];
};


export type AppMutationCreateDeliveryLocationArgs = {
  deliveryLocation?: Maybe<CompanyDeliveryLocationInput>;
  companyId: Scalars['Long'];
};


export type AppMutationUpdateDeliveryLocationArgs = {
  deliveryLocation?: Maybe<CompanyDeliveryLocationInput>;
};


export type AppMutationDeleteDeliveryLocationArgs = {
  deliveryLocationId: Scalars['Long'];
};


export type AppMutationChangePasswordByAdminArgs = {
  userName?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
  restaurantId: Scalars['Long'];
};


export type AppMutationCreateUserByAdminArgs = {
  userName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type AppMutationCreateSubsidiesArgs = {
  periodStart: Scalars['DateTime'];
  periodEnd: Scalars['DateTime'];
};


export type AppMutationAssignSubsidiesArgs = {
  period: Scalars['DateTime'];
};


export type AppMutationCreateMenuCategoryArgs = {
  menuCategory?: Maybe<RestaurantMenuCategoryInput>;
};


export type AppMutationCreateDishAllergenArgs = {
  dishAllergen?: Maybe<DishAllergeneInput>;
};


export type AppMutationDeleteDishAllergenArgs = {
  id: Scalars['Long'];
};


export type AppMutationUpdateMenuCategoryArgs = {
  menuCategory?: Maybe<RestaurantMenuCategoryInput>;
};


export type AppMutationUpdateDishAllergenArgs = {
  dishAllergen?: Maybe<DishAllergeneInput>;
};


export type AppMutationDeleteMenuCategoryArgs = {
  id: Scalars['Long'];
};


export type AppMutationConsumePasswordResetTokenArgs = {
  email?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
};


export type AppMutationCreateEmployeeBatchArgs = {
  data?: Maybe<CreateEmployeeDataInput>;
};


export type AppMutationChangePasswordArgs = {
  data?: Maybe<ChangePasswordDataInput>;
};


export type AppMutationSetDevicePushTokenArgs = {
  token?: Maybe<Scalars['String']>;
};


export type AppMutationCreateUserArgs = {
  createUserData?: Maybe<CreateUserDataInput>;
};


export type AppMutationCreateEmployeeUserArgs = {
  createUserData?: Maybe<CreateUserDataInput>;
  companyId: Scalars['Long'];
};


export type AppMutationUpdateUserArgs = {
  loginData?: Maybe<LoginDataInput>;
};


export type AppMutationDeleteUserArgs = {
  loginData?: Maybe<LoginDataInput>;
};


export type AppMutationCreateEmployeeArgs = {
  employee?: Maybe<CompanyEmployeeWithSubsidyAmountInput>;
  companyId: Scalars['Long'];
};


export type AppMutationCreateEmployeesFromExcelArgs = {
  excelContent?: Maybe<Scalars['String']>;
  companyId: Scalars['Long'];
};


export type AppMutationResetEmployeePasswordArgs = {
  employeeId: Scalars['Long'];
  companyId: Scalars['Long'];
};


export type AppMutationUpdateEmployeeArgs = {
  employee?: Maybe<CompanyEmployeeWithSubsidyAmountInput>;
  companyId: Scalars['Long'];
};


export type AppMutationDeleteEmployeeArgs = {
  employeeId: Scalars['Long'];
  companyId: Scalars['Long'];
};


export type AppMutationCreateEmployeeGroupArgs = {
  group?: Maybe<CompanyEmployeeGroupInput>;
  companyId: Scalars['Long'];
};


export type AppMutationUpdateEmployeeGroupArgs = {
  group?: Maybe<CompanyEmployeeGroupInput>;
  companyId: Scalars['Long'];
};


export type AppMutationDeleteEmployeeGroupArgs = {
  groupId: Scalars['Long'];
  companyId: Scalars['Long'];
};


export type AppMutationAddRestaurantDetailsArgs = {
  details?: Maybe<RestaurantDetailsInput>;
  languageId: Scalars['Long'];
  restaurantId: Scalars['Long'];
};


export type AppMutationDeleteRestaurantDetailsArgs = {
  detailsId: Scalars['Long'];
  restaurantId: Scalars['Long'];
};


export type AppMutationUpdateRestaurantDetailsArgs = {
  detailsId: Scalars['Long'];
  restaurantId: Scalars['Long'];
  details?: Maybe<RestaurantDetailsInput>;
};


export type AppMutationAddDishTemplateArgs = {
  dishTemplate?: Maybe<RestaurantDishTemplateInput>;
  restaurantId: Scalars['Long'];
};


export type AppMutationUpdateDishTemplateArgs = {
  dishTemplate?: Maybe<RestaurantDishTemplateInput>;
  restaurantId: Scalars['Long'];
};


export type AppMutationDeleteDishTemplateArgs = {
  dishTemplateId: Scalars['Long'];
  restaurantId: Scalars['Long'];
};


export type AppMutationAddRestaurantMenuArgs = {
  menu?: Maybe<RestaurantMenuInput>;
  restaurantId: Scalars['Long'];
};


export type AppMutationAddRestaurantMenuEntryArgs = {
  entry?: Maybe<RestaurantMenuEntryInput>;
  menuId?: Maybe<Scalars['Long']>;
  menuStartDay?: Maybe<Scalars['DateTime']>;
  menuEndDay?: Maybe<Scalars['DateTime']>;
  restaurantId: Scalars['Long'];
  addAsTemplate: Scalars['Boolean'];
};


export type AppMutationUpdateRestaurantMenuEntryArgs = {
  entry?: Maybe<RestaurantMenuEntryInput>;
  restaurantId: Scalars['Long'];
};


export type AppMutationDeleteRestaurantMenuEntryArgs = {
  menuEntryId: Scalars['Long'];
  restaurantId: Scalars['Long'];
};


export type AppMutationCopyLastWeekMenuArgs = {
  menuStartDay: Scalars['DateTime'];
  menuEndDay: Scalars['DateTime'];
  restaurantId: Scalars['Long'];
};


export type AppMutationCopySelectedWeekMenuArgs = {
  sourceMenuStartDay: Scalars['DateTime'];
  sourceMenuEndDay: Scalars['DateTime'];
  destMenuStartDay: Scalars['DateTime'];
  destMenuEndDay: Scalars['DateTime'];
  restaurantId: Scalars['Long'];
};


export type AppMutationToggleHideRestaurantMenuEntryArgs = {
  menuEntryId: Scalars['Long'];
  restaurantId: Scalars['Long'];
};


export type AppMutationToggleAcceptedRestaurantMenuEntryArgs = {
  menuEntryId: Scalars['Long'];
  restaurantId: Scalars['Long'];
};

export type AppQuery = {
  __typename?: 'AppQuery';
  restaurants?: Maybe<Array<Maybe<Restaurant>>>;
  restaurantDetails?: Maybe<DetailsRestaurant>;
  dishAllergens?: Maybe<Array<Maybe<DishAllergene>>>;
  menuCattegories?: Maybe<Array<Maybe<RestaurantMenuCategory>>>;
  contextData: Array<KeyValuePairOfStringAndObject>;
  scope?: Maybe<Scalars['String']>;
  name: Scalars['Name'];
  description?: Maybe<Scalars['String']>;
  login?: Maybe<TokenResponse>;
  refreshAccessToken?: Maybe<TokenResponse>;
  defaultCompanyWithDetails?: Maybe<AdminCompany>;
  companyBasicStats?: Maybe<CompanyBasicStats>;
  companyEmployeesWithoutOrders?: Maybe<Array<Maybe<CompanyEmployeeWithSubsidyAmount>>>;
  companyAllEmployees?: Maybe<Array<Maybe<CompanyEmployeeWithSubsidyAmount>>>;
  companyEmployeesGroups?: Maybe<Array<Maybe<CompanyEmployeeGroup>>>;
  companyRestaurants?: Maybe<Array<Maybe<RestaurantWithStats>>>;
  companyOrdersStatistics?: Maybe<CompanyOrdersStatistics>;
  employeeOrdersStatistics?: Maybe<EmployeeOrdersStatistics>;
  employeeGroupOrdersStatistics?: Maybe<EmployeeGroupOrdersStatistics>;
  restaurantOrdersStatistics?: Maybe<RestaurantOrdersStatistics>;
  GetCompanyEmployees?: Maybe<CompanyEmployeeWithSubsidyAmountConnection>;
  myOrders?: Maybe<Array<Maybe<EmployeeOrdersGroup>>>;
  defaultRestaurantWithDetails?: Maybe<AdminRestaurant>;
  adminRestaurantDetails?: Maybe<AdminRestaurant>;
  restaurantCompanies?: Maybe<Array<Maybe<CompanyWithStats>>>;
  restaurantComplaints?: Maybe<Array<Maybe<EmpioyeeOrderComplaintForList>>>;
  restaurantFinishedOrdersStatistics?: Maybe<RestaurantFinishedOrdersStatistics>;
  restaurantCompanyOrdersStatistics?: Maybe<CompanyOrdersStatistics>;
  allDishTemplates?: Maybe<Array<Maybe<RestaurantDishTemplate>>>;
  menuForWeek?: Maybe<RestaurantMenu>;
  restaurantOrders?: Maybe<Array<Maybe<EmployeeOrder>>>;
  currentRestaurantOrders?: Maybe<Array<Maybe<RestaurantCurrentOrder>>>;
  basicSettlementStats?: Maybe<RestaurantBasicSettlementAmount>;
  ordersStats?: Maybe<Array<Maybe<RestaurantDeliveryCount>>>;
  restaurantInvoices?: Maybe<Array<Maybe<RestaurantInvoice>>>;
  adminCurrencies?: Maybe<Array<Maybe<Currency>>>;
  adminLanguages?: Maybe<Array<Maybe<Language>>>;
  adminAllergenes?: Maybe<Array<Maybe<DishAllergene>>>;
  adminMenuCategories?: Maybe<Array<Maybe<RestaurantMenuCategory>>>;
  adminRestaurants?: Maybe<Array<Maybe<SuperAdminRestaurant>>>;
  adminCompanies?: Maybe<Array<Maybe<SuperAdminCompany>>>;
  sendResetEmail: Scalars['Boolean'];
  myData?: Maybe<UserData>;
  currencies?: Maybe<Array<Maybe<Currency>>>;
  languages?: Maybe<Array<Maybe<Language>>>;
};


export type AppQueryRestaurantDetailsArgs = {
  restaurantId: Scalars['Long'];
};


export type AppQueryLoginArgs = {
  loginData?: Maybe<LoginDataInput>;
};


export type AppQueryRefreshAccessTokenArgs = {
  refreshToken?: Maybe<Scalars['String']>;
};


export type AppQueryCompanyBasicStatsArgs = {
  companyId: Scalars['Long'];
};


export type AppQueryCompanyEmployeesWithoutOrdersArgs = {
  companyId: Scalars['Long'];
};


export type AppQueryCompanyAllEmployeesArgs = {
  companyId: Scalars['Long'];
};


export type AppQueryCompanyEmployeesGroupsArgs = {
  companyId: Scalars['Long'];
};


export type AppQueryCompanyRestaurantsArgs = {
  companyId: Scalars['Long'];
};


export type AppQueryCompanyOrdersStatisticsArgs = {
  companyId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};


export type AppQueryEmployeeOrdersStatisticsArgs = {
  companyId: Scalars['Long'];
  employeeId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};


export type AppQueryEmployeeGroupOrdersStatisticsArgs = {
  companyId: Scalars['Long'];
  groupId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};


export type AppQueryRestaurantOrdersStatisticsArgs = {
  companyId: Scalars['Long'];
  restaurantId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};


export type AppQueryGetCompanyEmployeesArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};


export type AppQueryMyOrdersArgs = {
  pastOrders: Scalars['Boolean'];
};


export type AppQueryAdminRestaurantDetailsArgs = {
  restaurantId: Scalars['Long'];
};


export type AppQueryRestaurantCompaniesArgs = {
  restaurantId: Scalars['Long'];
};


export type AppQueryRestaurantComplaintsArgs = {
  restaurantId: Scalars['Long'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
};


export type AppQueryRestaurantFinishedOrdersStatisticsArgs = {
  restaurantId: Scalars['Long'];
  companyId?: Maybe<Scalars['Long']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};


export type AppQueryRestaurantCompanyOrdersStatisticsArgs = {
  companyId: Scalars['Long'];
  restaurantId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};


export type AppQueryAllDishTemplatesArgs = {
  restaurantId: Scalars['Long'];
};


export type AppQueryMenuForWeekArgs = {
  dayInWeek: Scalars['DateTime'];
  restaurantId: Scalars['Long'];
};


export type AppQueryRestaurantOrdersArgs = {
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  deliveryLocationIds?: Maybe<Array<Scalars['Long']>>;
  companyIds?: Maybe<Array<Scalars['Long']>>;
  restaurantId: Scalars['Long'];
};


export type AppQueryCurrentRestaurantOrdersArgs = {
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  deliveryLocationIds?: Maybe<Array<Scalars['Long']>>;
  companyIds?: Maybe<Array<Scalars['Long']>>;
  restaurantId: Scalars['Long'];
};


export type AppQueryBasicSettlementStatsArgs = {
  restaurantId: Scalars['Long'];
};


export type AppQueryOrdersStatsArgs = {
  restaurantId: Scalars['Long'];
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
};


export type AppQueryRestaurantInvoicesArgs = {
  restaurantId: Scalars['Long'];
};


export type AppQuerySendResetEmailArgs = {
  languageCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export enum ApplyPolicy {
  BeforeResolver = 'BEFORE_RESOLVER',
  AfterResolver = 'AFTER_RESOLVER'
}

export type ChangePasswordDataInput = {
  oldPassword?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'Company';
  id: Scalars['Long'];
  details?: Maybe<Array<Maybe<CompanyDetails>>>;
};

export type CompanyBasicStats = {
  __typename?: 'CompanyBasicStats';
  totalEmployeesCount: Scalars['Int'];
  totalGroupsCount: Scalars['Int'];
  thisWeekOrdersCount: Scalars['Int'];
  thisMonthOrdersCount: Scalars['Int'];
};

export type CompanyDeliveryLocation = {
  __typename?: 'CompanyDeliveryLocation';
  id: Scalars['Long'];
  details?: Maybe<Array<Maybe<DeliveryLocationDetails>>>;
};

export type CompanyDeliveryLocationInput = {
  id: Scalars['Long'];
  details?: Maybe<Array<Maybe<DeliveryLocationDetailsInput>>>;
};

export type CompanyDetails = {
  __typename?: 'CompanyDetails';
  language?: Maybe<Language>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  bannerImageUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type CompanyDetailsInput = {
  language?: Maybe<LanguageInput>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  bannerImageUrl?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type CompanyEmployee = {
  __typename?: 'CompanyEmployee';
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<CompanyEmployeeNote>>>;
  language?: Maybe<Language>;
  employeeGroup?: Maybe<CompanyEmployeeGroup>;
  isDeactivated: Scalars['Boolean'];
  lastDeactivationDate?: Maybe<Scalars['DateTime']>;
  canMakeOrderFrom: Scalars['DateTime'];
  canMakeOrderTo: Scalars['DateTime'];
};

export type CompanyEmployeeGroup = {
  __typename?: 'CompanyEmployeeGroup';
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  subsidy?: Maybe<CompanyEmployeeSubsidyTemplate>;
};

export type CompanyEmployeeGroupInput = {
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  subsidy?: Maybe<CompanyEmployeeSubsidyTemplateInput>;
};

export type CompanyEmployeeInput = {
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<CompanyEmployeeNoteInput>>>;
  language?: Maybe<LanguageInput>;
  employeeGroup?: Maybe<CompanyEmployeeGroupInput>;
  isDeactivated: Scalars['Boolean'];
  lastDeactivationDate?: Maybe<Scalars['DateTime']>;
  canMakeOrderFrom: Scalars['DateTime'];
  canMakeOrderTo: Scalars['DateTime'];
};

export type CompanyEmployeeNote = {
  __typename?: 'CompanyEmployeeNote';
  id: Scalars['Long'];
  note?: Maybe<Scalars['String']>;
};

export type CompanyEmployeeNoteInput = {
  id: Scalars['Long'];
  note?: Maybe<Scalars['String']>;
};

export type CompanyEmployeeSubsidy = {
  __typename?: 'CompanyEmployeeSubsidy';
  quotaPeriodStart: Scalars['DateTime'];
  quotaPeriodEnd: Scalars['DateTime'];
  remainingSubsidy: Scalars['Float'];
  initialAmount: Scalars['Float'];
};

export type CompanyEmployeeSubsidyTemplate = {
  __typename?: 'CompanyEmployeeSubsidyTemplate';
  subsidyAmount: Scalars['Decimal'];
  subsidyPercentage: Scalars['Float'];
  dailySubsidyLimit: Scalars['Decimal'];
  dailyAmountLimit: Scalars['Decimal'];
  monthlyAmountLimit: Scalars['Decimal'];
  isOverSubsidyPaidByCompany: Scalars['Boolean'];
};

export type CompanyEmployeeSubsidyTemplateInput = {
  subsidyAmount: Scalars['Decimal'];
  subsidyPercentage: Scalars['Float'];
  dailySubsidyLimit: Scalars['Decimal'];
  dailyAmountLimit: Scalars['Decimal'];
  monthlyAmountLimit: Scalars['Decimal'];
  isOverSubsidyPaidByCompany: Scalars['Boolean'];
};

export type CompanyEmployeeWithSubsidyAmount = {
  __typename?: 'CompanyEmployeeWithSubsidyAmount';
  totalAmount: Scalars['Decimal'];
  subsidizedAmount: Scalars['Decimal'];
  lastOrderDate?: Maybe<Scalars['DateTime']>;
  lastOrderValue?: Maybe<Scalars['Decimal']>;
  remainingSubsidy?: Maybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<CompanyEmployeeNote>>>;
  language?: Maybe<Language>;
  employeeGroup?: Maybe<CompanyEmployeeGroup>;
  isDeactivated: Scalars['Boolean'];
  lastDeactivationDate?: Maybe<Scalars['DateTime']>;
  canMakeOrderFrom: Scalars['DateTime'];
  canMakeOrderTo: Scalars['DateTime'];
};

/** A connection to a list of items. */
export type CompanyEmployeeWithSubsidyAmountConnection = {
  __typename?: 'CompanyEmployeeWithSubsidyAmountConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<CompanyEmployeeWithSubsidyAmountEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<CompanyEmployeeWithSubsidyAmount>>>;
};

/** An edge in a connection. */
export type CompanyEmployeeWithSubsidyAmountEdge = {
  __typename?: 'CompanyEmployeeWithSubsidyAmountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyEmployeeWithSubsidyAmount>;
};

export type CompanyEmployeeWithSubsidyAmountInput = {
  totalAmount: Scalars['Decimal'];
  subsidizedAmount: Scalars['Decimal'];
  lastOrderDate?: Maybe<Scalars['DateTime']>;
  lastOrderValue?: Maybe<Scalars['Decimal']>;
  remainingSubsidy?: Maybe<Scalars['Decimal']>;
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<CompanyEmployeeNoteInput>>>;
  language?: Maybe<LanguageInput>;
  employeeGroup?: Maybe<CompanyEmployeeGroupInput>;
  isDeactivated: Scalars['Boolean'];
  lastDeactivationDate?: Maybe<Scalars['DateTime']>;
  canMakeOrderFrom: Scalars['DateTime'];
  canMakeOrderTo: Scalars['DateTime'];
};

export type CompanyOrdersStatistics = {
  __typename?: 'CompanyOrdersStatistics';
  totalOrdersCount: Scalars['Int'];
  totalOrdersValue: Scalars['Decimal'];
  totalSubsidizedOrdersValue: Scalars['Decimal'];
  yearStatistics?: Maybe<Array<Maybe<Stat>>>;
  monthStatistics?: Maybe<Array<Maybe<Stat>>>;
  weekStatistics?: Maybe<Array<Maybe<Stat>>>;
};

export type CompanyOwner = {
  __typename?: 'CompanyOwner';
  id: Scalars['Long'];
  username?: Maybe<Scalars['String']>;
};

export type CompanyOwnerInput = {
  id: Scalars['Long'];
  username?: Maybe<Scalars['String']>;
};

export type CompanyWithStats = {
  __typename?: 'CompanyWithStats';
  percentageOfAllOrders: Scalars['Decimal'];
  totalAmount: Scalars['Decimal'];
  totalOrdersCount: Scalars['Int'];
  currency?: Maybe<Currency>;
  id: Scalars['Long'];
  details?: Maybe<Array<Maybe<CompanyDetails>>>;
};

export type CreateEmployeeDataInput = {
  employeeGroupId: Scalars['Long'];
  employees?: Maybe<Array<Maybe<CompanyEmployeeInput>>>;
};

export type CreateEmployeeResult = {
  __typename?: 'CreateEmployeeResult';
  duplicateEmployees?: Maybe<Array<Maybe<CompanyEmployee>>>;
  errorEmployees?: Maybe<Array<Maybe<CompanyEmployee>>>;
};

export type CreateOrderDataInput = {
  restaurantId: Scalars['Long'];
  deliveryLocationId: Scalars['Long'];
  menuEntryId: Scalars['Long'];
  timeSlotId: Scalars['Long'];
  dayOfWeek: DayOfWeek;
};

export type CreateUserDataInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

export type Currency = {
  __typename?: 'Currency';
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

export type CurrencyInput = {
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};


export enum DayOfWeek {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY'
}


export type DeliveryLocation = {
  __typename?: 'DeliveryLocation';
  id: Scalars['Long'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  details?: Maybe<Array<Maybe<DeliveryLocationDetails>>>;
  timeSlots?: Maybe<Array<Maybe<DeliveryLocationTimeSlot>>>;
};

export type DeliveryLocationDetails = {
  __typename?: 'DeliveryLocationDetails';
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  language?: Maybe<Language>;
};

export type DeliveryLocationDetailsInput = {
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageInput>;
};

export type DeliveryLocationTimeSlot = {
  __typename?: 'DeliveryLocationTimeSlot';
  id: Scalars['Long'];
  time: Scalars['TimeSpan'];
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type DetailsRestaurant = {
  __typename?: 'DetailsRestaurant';
  menus?: Maybe<Array<Maybe<RestaurantMenu>>>;
  deliveryLocations?: Maybe<Array<Maybe<DeliveryLocation>>>;
  id: Scalars['Long'];
  currency?: Maybe<Currency>;
  details?: Maybe<Array<Maybe<RestaurantDetails>>>;
  stats?: Maybe<RestaurantsStats>;
};

export type DishAllergene = {
  __typename?: 'DishAllergene';
  id?: Maybe<Scalars['Long']>;
  details?: Maybe<Array<Maybe<DishAllergeneDetails>>>;
};

export type DishAllergeneDetails = {
  __typename?: 'DishAllergeneDetails';
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  language?: Maybe<Language>;
};

export type DishAllergeneDetailsInput = {
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageInput>;
};

export type DishAllergeneInput = {
  id?: Maybe<Scalars['Long']>;
  details?: Maybe<Array<Maybe<DishAllergeneDetailsInput>>>;
};

export type EmpioyeeOrderComplaint = {
  __typename?: 'EmpioyeeOrderComplaint';
  id: Scalars['Long'];
  complaintType: Scalars['Int'];
  isEmailSent: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  complaintText?: Maybe<Scalars['String']>;
};

export type EmpioyeeOrderComplaintForList = {
  __typename?: 'EmpioyeeOrderComplaintForList';
  dishName?: Maybe<Scalars['String']>;
  companyEmployee?: Maybe<CompanyEmployee>;
  id: Scalars['Long'];
  complaintType: Scalars['Int'];
  isEmailSent: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  complaintText?: Maybe<Scalars['String']>;
};

export type EmployeeGroupOrdersStatistics = {
  __typename?: 'EmployeeGroupOrdersStatistics';
  totalOrdersCount: Scalars['Int'];
  totalOrdersValue: Scalars['Decimal'];
  totalSubsidizedOrdersValue: Scalars['Decimal'];
  yearStatistics?: Maybe<Array<Maybe<Stat>>>;
  monthStatistics?: Maybe<Array<Maybe<Stat>>>;
  weekStatistics?: Maybe<Array<Maybe<Stat>>>;
};

export type EmployeeOrder = {
  __typename?: 'EmployeeOrder';
  id: Scalars['Long'];
  deliveryLocation?: Maybe<DeliveryLocation>;
  restaurant?: Maybe<Restaurant>;
  timeSlot?: Maybe<DeliveryLocationTimeSlot>;
  parentGroup?: Maybe<EmployeeOrdersGroup>;
  menuEntry?: Maybe<RestaurantMenuEntry>;
  company?: Maybe<Company>;
  totalAmount: Scalars['Decimal'];
  subsidizedAmount: Scalars['Decimal'];
  amountToPay: Scalars['Decimal'];
  createDateTime: Scalars['DateTime'];
  paymentStatus: PaymentStatus;
  overPaidForRestaurant: Scalars['Decimal'];
  overPaidForCompany: Scalars['Decimal'];
  paymentOrderId?: Maybe<Scalars['String']>;
  isGivenOut: Scalars['Boolean'];
  giveOutDateTime?: Maybe<Scalars['DateTime']>;
  amountToPayForRestaurant: Scalars['Decimal'];
  amountToPayForCompany: Scalars['Decimal'];
  amountToPayBasePrice: Scalars['Decimal'];
  ratingPoints: Scalars['Decimal'];
  ratingText?: Maybe<Scalars['String']>;
  isRated: Scalars['Boolean'];
  isComplaintMade: Scalars['Boolean'];
  dishName?: Maybe<Scalars['String']>;
  complaint?: Maybe<EmpioyeeOrderComplaint>;
  orderDeliveryDateTime: Scalars['DateTime'];
};

export type EmployeeOrdersGroup = {
  __typename?: 'EmployeeOrdersGroup';
  id: Scalars['Long'];
  deliveryLocation?: Maybe<DeliveryLocation>;
  restaurant?: Maybe<Restaurant>;
  timeSlot?: Maybe<DeliveryLocationTimeSlot>;
  dayOfWeek: DayOfWeek;
  periodStart: Scalars['DateTime'];
  periodEnd: Scalars['DateTime'];
  ordersDeliveryDateTime: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  orders?: Maybe<Array<Maybe<EmployeeOrder>>>;
  companyEmployee?: Maybe<CompanyEmployee>;
};

export type EmployeeOrdersStatistics = {
  __typename?: 'EmployeeOrdersStatistics';
  totalOrdersCount: Scalars['Int'];
  totalOrdersValue: Scalars['Decimal'];
  totalSubsidizedOrdersValue: Scalars['Decimal'];
  yearStatistics?: Maybe<Array<Maybe<Stat>>>;
  monthStatistics?: Maybe<Array<Maybe<Stat>>>;
  weekStatistics?: Maybe<Array<Maybe<Stat>>>;
};

export type KeyValuePairOfStringAndObject = {
  __typename?: 'KeyValuePairOfStringAndObject';
  key: Scalars['String'];
};

export type Language = {
  __typename?: 'Language';
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  englishName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type LanguageInput = {
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  englishName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type LoginDataInput = {
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};


export type LunchAppUser = {
  __typename?: 'LunchAppUser';
  id?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  isRegulationsConfirmed: Scalars['Boolean'];
  regulationsConfirmedDate: Scalars['DateTime'];
};

export type LunchAppUserEntity = {
  __typename?: 'LunchAppUserEntity';
  toModel?: Maybe<LunchAppUser>;
  refreshToken?: Maybe<Scalars['String']>;
  refreshTokenExpirationDate: Scalars['DateTime'];
  isRegulationsConfirmed: Scalars['Boolean'];
  regulationsConfirmedDate: Scalars['DateTime'];
  id: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  normalizedUserName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  normalizedEmail?: Maybe<Scalars['String']>;
  emailConfirmed: Scalars['Boolean'];
  passwordHash?: Maybe<Scalars['String']>;
  securityStamp?: Maybe<Scalars['String']>;
  concurrencyStamp?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberConfirmed: Scalars['Boolean'];
  twoFactorEnabled: Scalars['Boolean'];
  lockoutEnd?: Maybe<Scalars['DateTime']>;
  lockoutEnabled: Scalars['Boolean'];
  accessFailedCount: Scalars['Int'];
};


/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
};

export enum PaymentStatus {
  PaymentNotApplicable = 'PAYMENT_NOT_APPLICABLE',
  PaymentInitialized = 'PAYMENT_INITIALIZED',
  PaymentStarted = 'PAYMENT_STARTED',
  PaymentError = 'PAYMENT_ERROR',
  PaymentSuccess = 'PAYMENT_SUCCESS'
}

export type Restaurant = {
  __typename?: 'Restaurant';
  id: Scalars['Long'];
  currency?: Maybe<Currency>;
  details?: Maybe<Array<Maybe<RestaurantDetails>>>;
  stats?: Maybe<RestaurantsStats>;
};

export type RestaurantBasicSettlementAmount = {
  __typename?: 'RestaurantBasicSettlementAmount';
  thisMonthValue: Scalars['Float'];
  prevMonthValue: Scalars['Float'];
  thisMonthTotalAmount: Scalars['Float'];
  prevMonthTotalAmount: Scalars['Float'];
};

export type RestaurantCommisionDetails = {
  __typename?: 'RestaurantCommisionDetails';
  restaurantId: Scalars['Long'];
  companyId: Scalars['Long'];
  commisionAmount: Scalars['Float'];
};

export type RestaurantCommisionDetailsInput = {
  restaurantId: Scalars['Long'];
  companyId: Scalars['Long'];
  commisionAmount: Scalars['Float'];
};

export type RestaurantCurrentOrder = {
  __typename?: 'RestaurantCurrentOrder';
  id: Scalars['Long'];
  menuEntry?: Maybe<RestaurantMenuEntry>;
  employee?: Maybe<CompanyEmployee>;
  totalAmount: Scalars['Decimal'];
  isGivenOut: Scalars['Boolean'];
  isStickerPrinted: Scalars['Boolean'];
  giveOutDateTime?: Maybe<Scalars['DateTime']>;
  deliveryDateTime: Scalars['DateTime'];
  company?: Maybe<Company>;
  deliveryLocation?: Maybe<DeliveryLocation>;
  overPaidForRestaurant: Scalars['Decimal'];
};

export type RestaurantDeliveryCount = {
  __typename?: 'RestaurantDeliveryCount';
  company?: Maybe<Company>;
  deliveryCount: Scalars['Int'];
  totalAmount: Scalars['Float'];
  toRealizeCount: Scalars['Int'];
  toRealizeAmount: Scalars['Float'];
};

export type RestaurantDetails = {
  __typename?: 'RestaurantDetails';
  id: Scalars['Long'];
  language?: Maybe<Language>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type RestaurantDetailsInput = {
  id: Scalars['Long'];
  language?: Maybe<LanguageInput>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type RestaurantDishTemplate = {
  __typename?: 'RestaurantDishTemplate';
  id?: Maybe<Scalars['Long']>;
  price: Scalars['Decimal'];
  priceForRestaurant: Scalars['Decimal'];
  basePrice: Scalars['Decimal'];
  isAccepted: Scalars['Boolean'];
  details?: Maybe<Array<Maybe<RestaurantDishTemplateDetails>>>;
  categories?: Maybe<Array<Maybe<RestaurantMenuCategory>>>;
  allergenes?: Maybe<Array<Maybe<DishAllergene>>>;
  imageData?: Maybe<Scalars['String']>;
  menuEntries?: Maybe<Array<Maybe<RestaurantMenuEntry>>>;
  ratingPointsSum: Scalars['Decimal'];
  ratingPointsCount: Scalars['Int'];
};

export type RestaurantDishTemplateDetails = {
  __typename?: 'RestaurantDishTemplateDetails';
  id?: Maybe<Scalars['Long']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>;
  parts?: Maybe<Array<Maybe<Scalars['String']>>>;
  estimatedPreparationTime: Scalars['TimeSpan'];
  language?: Maybe<Language>;
};

export type RestaurantDishTemplateDetailsInput = {
  id?: Maybe<Scalars['Long']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>;
  parts?: Maybe<Array<Maybe<Scalars['String']>>>;
  estimatedPreparationTime: Scalars['TimeSpan'];
  language?: Maybe<LanguageInput>;
};

export type RestaurantDishTemplateInput = {
  id?: Maybe<Scalars['Long']>;
  price: Scalars['Decimal'];
  priceForRestaurant: Scalars['Decimal'];
  basePrice: Scalars['Decimal'];
  isAccepted: Scalars['Boolean'];
  details?: Maybe<Array<Maybe<RestaurantDishTemplateDetailsInput>>>;
  categories?: Maybe<Array<Maybe<RestaurantMenuCategoryInput>>>;
  allergenes?: Maybe<Array<Maybe<DishAllergeneInput>>>;
  imageData?: Maybe<Scalars['String']>;
  menuEntries?: Maybe<Array<Maybe<RestaurantMenuEntryInput>>>;
  ratingPointsSum: Scalars['Decimal'];
  ratingPointsCount: Scalars['Int'];
};

export type RestaurantFinishedOrdersStatistics = {
  __typename?: 'RestaurantFinishedOrdersStatistics';
  totalOrdersCount: Scalars['Int'];
  totalOrdersValue: Scalars['Decimal'];
  totalFoodApkaOrdersValue: Scalars['Decimal'];
  yearStatistics?: Maybe<Array<Maybe<RestaurantStat>>>;
  monthStatistics?: Maybe<Array<Maybe<RestaurantStat>>>;
  weekStatistics?: Maybe<Array<Maybe<RestaurantStat>>>;
};

export type RestaurantInput = {
  id: Scalars['Long'];
  currency?: Maybe<CurrencyInput>;
  details?: Maybe<Array<Maybe<RestaurantDetailsInput>>>;
  stats?: Maybe<RestaurantsStatsInput>;
};

export type RestaurantInvoice = {
  __typename?: 'RestaurantInvoice';
  id: Scalars['Long'];
  restaurantId: Scalars['Long'];
  issueData: Scalars['DateTime'];
  periodStart: Scalars['DateTime'];
  periodEnd: Scalars['DateTime'];
  ordersCount: Scalars['Int'];
  ordersValue: Scalars['Decimal'];
  calculatedValue: Scalars['Decimal'];
  paidDate: Scalars['DateTime'];
};

export type RestaurantMenu = {
  __typename?: 'RestaurantMenu';
  id?: Maybe<Scalars['Long']>;
  entries?: Maybe<Array<Maybe<RestaurantMenuEntry>>>;
  menuStartDay?: Maybe<Scalars['DateTime']>;
  menuEndDay?: Maybe<Scalars['DateTime']>;
};

export type RestaurantMenuCategory = {
  __typename?: 'RestaurantMenuCategory';
  id?: Maybe<Scalars['Long']>;
  details?: Maybe<Array<Maybe<RestaurantMenuCategoryDetails>>>;
};

export type RestaurantMenuCategoryDetails = {
  __typename?: 'RestaurantMenuCategoryDetails';
  id: Scalars['Long'];
  language?: Maybe<Language>;
  categoryName?: Maybe<Scalars['String']>;
};

export type RestaurantMenuCategoryDetailsInput = {
  id: Scalars['Long'];
  language?: Maybe<LanguageInput>;
  categoryName?: Maybe<Scalars['String']>;
};

export type RestaurantMenuCategoryInput = {
  id?: Maybe<Scalars['Long']>;
  details?: Maybe<Array<Maybe<RestaurantMenuCategoryDetailsInput>>>;
};

export type RestaurantMenuEntry = {
  __typename?: 'RestaurantMenuEntry';
  id?: Maybe<Scalars['Long']>;
  entryOfTheDay?: Maybe<Scalars['DateTime']>;
  entryOfTheDays?: Maybe<Array<Scalars['DateTime']>>;
  price: Scalars['Decimal'];
  dishOfTheDayPrice: Scalars['Decimal'];
  priceForRestaurant: Scalars['Decimal'];
  basePrice: Scalars['Decimal'];
  imageData?: Maybe<Scalars['String']>;
  details?: Maybe<Array<Maybe<RestaurantMenuEntryDetails>>>;
  categories?: Maybe<Array<Maybe<RestaurantMenuCategory>>>;
  allergenes?: Maybe<Array<Maybe<DishAllergene>>>;
  isHidden: Scalars['Boolean'];
  isAccepted: Scalars['Boolean'];
  stats?: Maybe<RestaurantMenuEntryStats>;
  dishTemplate?: Maybe<RestaurantDishTemplate>;
  ratingPointsSum: Scalars['Decimal'];
  ratingPointsCount: Scalars['Int'];
};

export type RestaurantMenuEntryDetails = {
  __typename?: 'RestaurantMenuEntryDetails';
  id?: Maybe<Scalars['Long']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>;
  parts?: Maybe<Array<Maybe<Scalars['String']>>>;
  estimatedPreparationTime: Scalars['TimeSpan'];
  language?: Maybe<Language>;
};

export type RestaurantMenuEntryDetailsInput = {
  id?: Maybe<Scalars['Long']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>;
  parts?: Maybe<Array<Maybe<Scalars['String']>>>;
  estimatedPreparationTime: Scalars['TimeSpan'];
  language?: Maybe<LanguageInput>;
};

export type RestaurantMenuEntryInput = {
  id?: Maybe<Scalars['Long']>;
  entryOfTheDay?: Maybe<Scalars['DateTime']>;
  entryOfTheDays?: Maybe<Array<Scalars['DateTime']>>;
  price: Scalars['Decimal'];
  dishOfTheDayPrice: Scalars['Decimal'];
  priceForRestaurant: Scalars['Decimal'];
  basePrice: Scalars['Decimal'];
  imageData?: Maybe<Scalars['String']>;
  details?: Maybe<Array<Maybe<RestaurantMenuEntryDetailsInput>>>;
  categories?: Maybe<Array<Maybe<RestaurantMenuCategoryInput>>>;
  allergenes?: Maybe<Array<Maybe<DishAllergeneInput>>>;
  isHidden: Scalars['Boolean'];
  isAccepted: Scalars['Boolean'];
  stats?: Maybe<RestaurantMenuEntryStatsInput>;
  dishTemplate?: Maybe<RestaurantDishTemplateInput>;
  ratingPointsSum: Scalars['Decimal'];
  ratingPointsCount: Scalars['Int'];
};

export type RestaurantMenuEntryStats = {
  __typename?: 'RestaurantMenuEntryStats';
  orderCount: Scalars['Int'];
  totalAmount: Scalars['Decimal'];
};

export type RestaurantMenuEntryStatsInput = {
  orderCount: Scalars['Int'];
  totalAmount: Scalars['Decimal'];
};

export type RestaurantMenuInput = {
  id?: Maybe<Scalars['Long']>;
  entries?: Maybe<Array<Maybe<RestaurantMenuEntryInput>>>;
  menuStartDay?: Maybe<Scalars['DateTime']>;
  menuEndDay?: Maybe<Scalars['DateTime']>;
};

export type RestaurantOrdersStatistics = {
  __typename?: 'RestaurantOrdersStatistics';
  totalOrdersCount: Scalars['Int'];
  totalOrdersValue: Scalars['Decimal'];
  totalSubsidizedOrdersValue: Scalars['Decimal'];
  yearStatistics?: Maybe<Array<Maybe<Stat>>>;
  monthStatistics?: Maybe<Array<Maybe<Stat>>>;
  weekStatistics?: Maybe<Array<Maybe<Stat>>>;
};

export type RestaurantOwner = {
  __typename?: 'RestaurantOwner';
  id: Scalars['Long'];
  username?: Maybe<Scalars['String']>;
};

export type RestaurantSettingsAdmin = {
  __typename?: 'RestaurantSettingsAdmin';
  testMode: Scalars['Boolean'];
  paymentPosId?: Maybe<Scalars['String']>;
  paymentSalt?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  defaultDishOfTheDayPrice: Scalars['Float'];
  provisionPercentage: Scalars['Decimal'];
  provisionForCompanyPercentage: Scalars['Decimal'];
  complaintEmailAddress?: Maybe<Scalars['String']>;
  ratingEmailAddress?: Maybe<Scalars['String']>;
};

export type RestaurantSettingsAdminInput = {
  testMode: Scalars['Boolean'];
  paymentPosId?: Maybe<Scalars['String']>;
  paymentSalt?: Maybe<Scalars['String']>;
  id: Scalars['Long'];
  defaultDishOfTheDayPrice: Scalars['Float'];
  provisionPercentage: Scalars['Decimal'];
  provisionForCompanyPercentage: Scalars['Decimal'];
  complaintEmailAddress?: Maybe<Scalars['String']>;
  ratingEmailAddress?: Maybe<Scalars['String']>;
};

export type RestaurantStat = {
  __typename?: 'RestaurantStat';
  key: Scalars['Int'];
  count: Scalars['Int'];
  amount: Scalars['Decimal'];
  foodApkaAmount: Scalars['Decimal'];
};

export type RestaurantWithStats = {
  __typename?: 'RestaurantWithStats';
  totalAmount: Scalars['Decimal'];
  totalOrdersCount: Scalars['Int'];
  totalDishCount: Scalars['Int'];
  id: Scalars['Long'];
  currency?: Maybe<Currency>;
  details?: Maybe<Array<Maybe<RestaurantDetails>>>;
  stats?: Maybe<RestaurantsStats>;
};

export type RestaurantsStats = {
  __typename?: 'RestaurantsStats';
  percentageOfAllOrders: Scalars['Float'];
};

export type RestaurantsStatsInput = {
  percentageOfAllOrders: Scalars['Float'];
};

export type Stat = {
  __typename?: 'Stat';
  key: Scalars['Int'];
  count: Scalars['Int'];
  amount: Scalars['Decimal'];
  subsidizedAmount: Scalars['Decimal'];
};

export type SuperAdminCompany = {
  __typename?: 'SuperAdminCompany';
  owners?: Maybe<Array<Maybe<AdminCompanyOwner>>>;
  restaurants?: Maybe<Array<Maybe<Restaurant>>>;
  employeeGroups?: Maybe<Array<Maybe<CompanyEmployeeGroup>>>;
  deliveryLocations?: Maybe<Array<Maybe<CompanyDeliveryLocation>>>;
  id: Scalars['Long'];
  details?: Maybe<Array<Maybe<CompanyDetails>>>;
};

export type SuperAdminRestaurant = {
  __typename?: 'SuperAdminRestaurant';
  companies?: Maybe<Array<Maybe<AdminCompany>>>;
  owners?: Maybe<Array<Maybe<AdminRestaurantOwner>>>;
  deliveryLocations?: Maybe<Array<Maybe<AdminDeliveryLocation>>>;
  settings?: Maybe<RestaurantSettingsAdmin>;
  commisionDetails?: Maybe<Array<Maybe<RestaurantCommisionDetails>>>;
  id: Scalars['Long'];
  currency?: Maybe<Currency>;
  details?: Maybe<Array<Maybe<RestaurantDetails>>>;
  stats?: Maybe<RestaurantsStats>;
};

export type SuperAdminRestaurantInput = {
  companies?: Maybe<Array<Maybe<AdminCompanyInput>>>;
  owners?: Maybe<Array<Maybe<AdminRestaurantOwnerInput>>>;
  deliveryLocations?: Maybe<Array<Maybe<AdminDeliveryLocationInput>>>;
  settings?: Maybe<RestaurantSettingsAdminInput>;
  commisionDetails?: Maybe<Array<Maybe<RestaurantCommisionDetailsInput>>>;
  id: Scalars['Long'];
  currency?: Maybe<CurrencyInput>;
  details?: Maybe<Array<Maybe<RestaurantDetailsInput>>>;
  stats?: Maybe<RestaurantsStatsInput>;
};


export type TokenResponse = {
  __typename?: 'TokenResponse';
  id?: Maybe<Scalars['String']>;
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  accessTokenExpirationDate: Scalars['DateTime'];
  refreshTokenExpirationDate: Scalars['DateTime'];
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UserData = {
  __typename?: 'UserData';
  mySubsidy?: Maybe<CompanyEmployeeSubsidy>;
  me?: Maybe<CompanyEmployee>;
  myCompany?: Maybe<Company>;
  myStats?: Maybe<UserStats>;
  myCurrency?: Maybe<Currency>;
};

export type UserMonthData = {
  __typename?: 'UserMonthData';
  month: Scalars['Int'];
  spent: Scalars['Float'];
};

export type UserStats = {
  __typename?: 'UserStats';
  ordersThisMonth: Scalars['Int'];
  spentThisMonth: Scalars['Float'];
  subsidyAmountThisMonth: Scalars['Float'];
  weekData?: Maybe<Array<Maybe<UserWeekData>>>;
  monthData?: Maybe<Array<Maybe<UserMonthData>>>;
};

export type UserWeekData = {
  __typename?: 'UserWeekData';
  week: Scalars['Int'];
  spentPerDay?: Maybe<Array<Scalars['Float']>>;
};

export type CompanyEmployeeGroupFragment = (
  { __typename?: 'CompanyEmployeeGroup' }
  & Pick<CompanyEmployeeGroup, 'id' | 'name'>
  & { subsidy?: Maybe<(
    { __typename?: 'CompanyEmployeeSubsidyTemplate' }
    & Pick<CompanyEmployeeSubsidyTemplate, 'subsidyPercentage' | 'subsidyAmount' | 'dailySubsidyLimit' | 'monthlyAmountLimit' | 'dailyAmountLimit' | 'isOverSubsidyPaidByCompany'>
  )> }
);

export type CurrencyFragment = (
  { __typename?: 'Currency' }
  & Pick<Currency, 'id' | 'name' | 'symbol' | 'shortName'>
);

export type RestaurantMenuCategoryFragment = (
  { __typename?: 'RestaurantMenuCategory' }
  & Pick<RestaurantMenuCategory, 'id'>
  & { details?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantMenuCategoryDetails' }
    & Pick<RestaurantMenuCategoryDetails, 'id' | 'categoryName'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'code'>
    )> }
  )>>> }
);

export type DishAllergeneFragment = (
  { __typename?: 'DishAllergene' }
  & Pick<DishAllergene, 'id'>
  & { details?: Maybe<Array<Maybe<(
    { __typename?: 'DishAllergeneDetails' }
    & Pick<DishAllergeneDetails, 'id' | 'name'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'code'>
    )> }
  )>>> }
);

export type AdminCompanyFragment = (
  { __typename?: 'AdminCompany' }
  & Pick<AdminCompany, 'id'>
  & { details?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyDetails' }
    & Pick<CompanyDetails, 'name' | 'description' | 'bannerImageUrl'>
  )>>>, restaurants?: Maybe<Array<Maybe<(
    { __typename?: 'Restaurant' }
    & Pick<Restaurant, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'RestaurantDetails' }
      & Pick<RestaurantDetails, 'id' | 'name' | 'description' | 'imageUrl'>
    )>>> }
  )>>>, employeeGroups?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyEmployeeGroup' }
    & Pick<CompanyEmployeeGroup, 'id' | 'name'>
    & { subsidy?: Maybe<(
      { __typename?: 'CompanyEmployeeSubsidyTemplate' }
      & Pick<CompanyEmployeeSubsidyTemplate, 'subsidyPercentage' | 'subsidyAmount' | 'dailySubsidyLimit' | 'monthlyAmountLimit' | 'dailyAmountLimit' | 'isOverSubsidyPaidByCompany'>
    )> }
  )>>> }
);

export type SuperAdminCompanyFragment = (
  { __typename?: 'SuperAdminCompany' }
  & Pick<SuperAdminCompany, 'id'>
  & { owners?: Maybe<Array<Maybe<(
    { __typename?: 'AdminCompanyOwner' }
    & Pick<AdminCompanyOwner, 'id' | 'username' | 'email' | 'authId'>
  )>>>, details?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyDetails' }
    & Pick<CompanyDetails, 'name' | 'description' | 'bannerImageUrl' | 'thumbnailUrl'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
    )> }
  )>>>, restaurants?: Maybe<Array<Maybe<(
    { __typename?: 'Restaurant' }
    & Pick<Restaurant, 'id'>
    & { currency?: Maybe<(
      { __typename?: 'Currency' }
      & Pick<Currency, 'id' | 'name' | 'symbol' | 'shortName'>
    )>, details?: Maybe<Array<Maybe<(
      { __typename?: 'RestaurantDetails' }
      & Pick<RestaurantDetails, 'id' | 'name' | 'description' | 'imageUrl'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
      )> }
    )>>> }
  )>>>, deliveryLocations?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyDeliveryLocation' }
    & Pick<CompanyDeliveryLocation, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'DeliveryLocationDetails' }
      & Pick<DeliveryLocationDetails, 'id' | 'name' | 'description' | 'imageUrl'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'id' | 'name' | 'code'>
      )> }
    )>>> }
  )>>> }
);

export type AdminCompanyOwnerFragment = (
  { __typename?: 'AdminCompanyOwner' }
  & Pick<AdminCompanyOwner, 'id' | 'username' | 'authId' | 'email'>
);

export type CompanyDeliveryLocationFragment = (
  { __typename?: 'CompanyDeliveryLocation' }
  & Pick<CompanyDeliveryLocation, 'id'>
  & { details?: Maybe<Array<Maybe<(
    { __typename?: 'DeliveryLocationDetails' }
    & Pick<DeliveryLocationDetails, 'id' | 'name' | 'description' | 'imageUrl'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
    )> }
  )>>> }
);

export type CompanyBasicStatsFragment = (
  { __typename?: 'CompanyBasicStats' }
  & Pick<CompanyBasicStats, 'totalEmployeesCount' | 'totalGroupsCount' | 'thisWeekOrdersCount' | 'thisMonthOrdersCount'>
);

export type CompanyEmployeeEditFragment = (
  { __typename?: 'CompanyEmployee' }
  & Pick<CompanyEmployee, 'id' | 'name' | 'surname' | 'email' | 'code'>
  & { employeeGroup?: Maybe<(
    { __typename?: 'CompanyEmployeeGroup' }
    & Pick<CompanyEmployeeGroup, 'id' | 'name'>
  )> }
);

export type CompanyEmployeeWithSubsidyAmountFragment = (
  { __typename?: 'CompanyEmployeeWithSubsidyAmount' }
  & Pick<CompanyEmployeeWithSubsidyAmount, 'id' | 'name' | 'surname' | 'totalAmount' | 'subsidizedAmount' | 'lastOrderDate' | 'lastOrderValue' | 'email' | 'code' | 'remainingSubsidy' | 'isDeactivated' | 'canMakeOrderFrom' | 'canMakeOrderTo' | 'lastDeactivationDate'>
  & { employeeGroup?: Maybe<(
    { __typename?: 'CompanyEmployeeGroup' }
    & Pick<CompanyEmployeeGroup, 'id' | 'name'>
    & { subsidy?: Maybe<(
      { __typename?: 'CompanyEmployeeSubsidyTemplate' }
      & Pick<CompanyEmployeeSubsidyTemplate, 'subsidyPercentage' | 'subsidyAmount' | 'dailySubsidyLimit' | 'monthlyAmountLimit' | 'dailyAmountLimit' | 'isOverSubsidyPaidByCompany'>
    )> }
  )> }
);

export type CompanyOrdersStatisticsFragment = (
  { __typename?: 'CompanyOrdersStatistics' }
  & Pick<CompanyOrdersStatistics, 'totalOrdersCount' | 'totalOrdersValue' | 'totalSubsidizedOrdersValue'>
  & { yearStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>>, monthStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>>, weekStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>> }
);

export type RestaurantOrdersStatisticsFragment = (
  { __typename?: 'RestaurantOrdersStatistics' }
  & Pick<RestaurantOrdersStatistics, 'totalOrdersCount' | 'totalOrdersValue' | 'totalSubsidizedOrdersValue'>
  & { yearStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>>, monthStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>>, weekStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>> }
);

export type EmployeeOrdersStatisticsFragment = (
  { __typename?: 'EmployeeOrdersStatistics' }
  & Pick<EmployeeOrdersStatistics, 'totalOrdersCount' | 'totalOrdersValue' | 'totalSubsidizedOrdersValue'>
  & { yearStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>>, monthStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>>, weekStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>> }
);

export type EmployeeGroupOrdersStatisticsFragment = (
  { __typename?: 'EmployeeGroupOrdersStatistics' }
  & Pick<EmployeeGroupOrdersStatistics, 'totalOrdersCount' | 'totalOrdersValue' | 'totalSubsidizedOrdersValue'>
  & { yearStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>>, monthStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>>, weekStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'Stat' }
    & Pick<Stat, 'key' | 'count' | 'amount' | 'subsidizedAmount'>
  )>>> }
);

export type RestaurantWithStatsFragment = (
  { __typename?: 'RestaurantWithStats' }
  & Pick<RestaurantWithStats, 'id' | 'totalAmount' | 'totalOrdersCount' | 'totalDishCount'>
  & { currency?: Maybe<(
    { __typename?: 'Currency' }
    & Pick<Currency, 'id' | 'name' | 'symbol' | 'shortName'>
  )>, details?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantDetails' }
    & Pick<RestaurantDetails, 'id' | 'name' | 'description' | 'imageUrl'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'code' | 'name'>
    )> }
  )>>>, stats?: Maybe<(
    { __typename?: 'RestaurantsStats' }
    & Pick<RestaurantsStats, 'percentageOfAllOrders'>
  )> }
);

export type EmployeeOrderForTableFragment = (
  { __typename?: 'EmployeeOrder' }
  & Pick<EmployeeOrder, 'id' | 'totalAmount' | 'amountToPayForRestaurant' | 'amountToPayBasePrice' | 'createDateTime' | 'isGivenOut' | 'giveOutDateTime'>
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'CompanyDetails' }
      & Pick<CompanyDetails, 'name'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )>, deliveryLocation?: Maybe<(
    { __typename?: 'DeliveryLocation' }
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'DeliveryLocationDetails' }
      & Pick<DeliveryLocationDetails, 'name'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )>, parentGroup?: Maybe<(
    { __typename?: 'EmployeeOrdersGroup' }
    & Pick<EmployeeOrdersGroup, 'periodEnd' | 'ordersDeliveryDateTime'>
    & { companyEmployee?: Maybe<(
      { __typename?: 'CompanyEmployee' }
      & Pick<CompanyEmployee, 'id' | 'name' | 'surname'>
    )> }
  )>, menuEntry?: Maybe<(
    { __typename?: 'RestaurantMenuEntry' }
    & RestaurantMenuEntryFragment
  )> }
);

export type RestaurantCurrentOrderFragment = (
  { __typename?: 'RestaurantCurrentOrder' }
  & Pick<RestaurantCurrentOrder, 'id' | 'totalAmount' | 'overPaidForRestaurant' | 'isGivenOut' | 'giveOutDateTime' | 'deliveryDateTime' | 'isStickerPrinted'>
  & { menuEntry?: Maybe<(
    { __typename?: 'RestaurantMenuEntry' }
    & RestaurantMenuEntryFragment
  )>, employee?: Maybe<(
    { __typename?: 'CompanyEmployee' }
    & Pick<CompanyEmployee, 'name' | 'surname'>
  )>, deliveryLocation?: Maybe<(
    { __typename?: 'DeliveryLocation' }
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'DeliveryLocationDetails' }
      & Pick<DeliveryLocationDetails, 'name'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )>, company?: Maybe<(
    { __typename?: 'Company' }
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'CompanyDetails' }
      & Pick<CompanyDetails, 'name'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )> }
);

export type RestaurantDishTemplateFragment = (
  { __typename?: 'RestaurantDishTemplate' }
  & Pick<RestaurantDishTemplate, 'id' | 'price' | 'basePrice' | 'priceForRestaurant' | 'isAccepted' | 'ratingPointsCount' | 'ratingPointsSum'>
  & { details?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantDishTemplateDetails' }
    & Pick<RestaurantDishTemplateDetails, 'title' | 'description' | 'imageUrl' | 'ingredients' | 'parts' | 'estimatedPreparationTime'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'code'>
    )> }
  )>>>, categories?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantMenuCategory' }
    & Pick<RestaurantMenuCategory, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'RestaurantMenuCategoryDetails' }
      & Pick<RestaurantMenuCategoryDetails, 'id' | 'categoryName'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )>>>, allergenes?: Maybe<Array<Maybe<(
    { __typename?: 'DishAllergene' }
    & Pick<DishAllergene, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'DishAllergeneDetails' }
      & Pick<DishAllergeneDetails, 'id' | 'name'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )>>> }
);

export type RestaurantMenuEntryFragment = (
  { __typename?: 'RestaurantMenuEntry' }
  & Pick<RestaurantMenuEntry, 'id' | 'price' | 'basePrice' | 'priceForRestaurant' | 'dishOfTheDayPrice' | 'entryOfTheDay' | 'entryOfTheDays' | 'isHidden' | 'isAccepted' | 'ratingPointsCount' | 'ratingPointsSum'>
  & { details?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantMenuEntryDetails' }
    & Pick<RestaurantMenuEntryDetails, 'id' | 'title' | 'description' | 'ingredients' | 'imageUrl' | 'estimatedPreparationTime'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'code'>
    )> }
  )>>>, stats?: Maybe<(
    { __typename?: 'RestaurantMenuEntryStats' }
    & Pick<RestaurantMenuEntryStats, 'orderCount' | 'totalAmount'>
  )>, categories?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantMenuCategory' }
    & Pick<RestaurantMenuCategory, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'RestaurantMenuCategoryDetails' }
      & Pick<RestaurantMenuCategoryDetails, 'id' | 'categoryName'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'id' | 'code'>
      )> }
    )>>> }
  )>>>, allergenes?: Maybe<Array<Maybe<(
    { __typename?: 'DishAllergene' }
    & Pick<DishAllergene, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'DishAllergeneDetails' }
      & Pick<DishAllergeneDetails, 'id' | 'name'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'id' | 'code'>
      )> }
    )>>> }
  )>>>, dishTemplate?: Maybe<(
    { __typename?: 'RestaurantDishTemplate' }
    & RestaurantDishTemplateFragment
  )> }
);

export type RestaurantMenuFragment = (
  { __typename?: 'RestaurantMenu' }
  & Pick<RestaurantMenu, 'id' | 'menuStartDay' | 'menuEndDay'>
  & { entries?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantMenuEntry' }
    & RestaurantMenuEntryFragment
  )>>> }
);

export type RestaurantInvoiceFragment = (
  { __typename?: 'RestaurantInvoice' }
  & Pick<RestaurantInvoice, 'restaurantId' | 'issueData' | 'periodStart' | 'periodEnd' | 'ordersCount' | 'ordersValue' | 'calculatedValue'>
);

export type RestaurantDeliveryCountFragment = (
  { __typename?: 'RestaurantDeliveryCount' }
  & Pick<RestaurantDeliveryCount, 'deliveryCount' | 'totalAmount' | 'toRealizeCount' | 'toRealizeAmount'>
  & { company?: Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'CompanyDetails' }
      & Pick<CompanyDetails, 'name'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )> }
);

export type RestaurantBasicSettlementAmountFragment = (
  { __typename?: 'RestaurantBasicSettlementAmount' }
  & Pick<RestaurantBasicSettlementAmount, 'thisMonthValue' | 'prevMonthValue' | 'thisMonthTotalAmount' | 'prevMonthTotalAmount'>
);

export type RestaurantFinishedOrdersStatisticsFragment = (
  { __typename?: 'RestaurantFinishedOrdersStatistics' }
  & Pick<RestaurantFinishedOrdersStatistics, 'totalOrdersCount' | 'totalOrdersValue' | 'totalFoodApkaOrdersValue'>
  & { yearStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantStat' }
    & Pick<RestaurantStat, 'key' | 'count' | 'amount' | 'foodApkaAmount'>
  )>>>, monthStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantStat' }
    & Pick<RestaurantStat, 'key' | 'count' | 'amount' | 'foodApkaAmount'>
  )>>>, weekStatistics?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantStat' }
    & Pick<RestaurantStat, 'key' | 'count' | 'amount' | 'foodApkaAmount'>
  )>>> }
);

export type AdminRestaurantOwnerFragment = (
  { __typename?: 'AdminRestaurantOwner' }
  & Pick<AdminRestaurantOwner, 'id' | 'username' | 'authId' | 'email'>
);

export type AdminRestaurantFragment = (
  { __typename?: 'AdminRestaurant' }
  & Pick<AdminRestaurant, 'id'>
  & { owners?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantOwner' }
    & Pick<RestaurantOwner, 'id' | 'username'>
  )>>>, deliveryLocations?: Maybe<Array<Maybe<(
    { __typename?: 'DeliveryLocation' }
    & Pick<DeliveryLocation, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'DeliveryLocationDetails' }
      & Pick<DeliveryLocationDetails, 'id' | 'name' | 'description'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
      )> }
    )>>>, timeSlots?: Maybe<Array<Maybe<(
      { __typename?: 'DeliveryLocationTimeSlot' }
      & Pick<DeliveryLocationTimeSlot, 'id' | 'time' | 'hour' | 'minute'>
    )>>> }
  )>>>, companies?: Maybe<Array<Maybe<(
    { __typename?: 'Company' }
    & Pick<Company, 'id'>
  )>>>, currency?: Maybe<(
    { __typename?: 'Currency' }
    & Pick<Currency, 'id' | 'name' | 'symbol' | 'shortName'>
  )>, details?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantDetails' }
    & Pick<RestaurantDetails, 'id' | 'name' | 'description' | 'imageUrl'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
    )> }
  )>>>, commisionDetails?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantCommisionDetails' }
    & Pick<RestaurantCommisionDetails, 'restaurantId' | 'companyId' | 'commisionAmount'>
  )>>>, settings?: Maybe<(
    { __typename?: 'RestaurantSettingsAdmin' }
    & Pick<RestaurantSettingsAdmin, 'paymentPosId' | 'paymentSalt'>
  )> }
);

export type SuperAdminRestaurantFragment = (
  { __typename?: 'SuperAdminRestaurant' }
  & Pick<SuperAdminRestaurant, 'id'>
  & { owners?: Maybe<Array<Maybe<(
    { __typename?: 'AdminRestaurantOwner' }
    & Pick<AdminRestaurantOwner, 'id' | 'username' | 'email' | 'authId'>
  )>>>, deliveryLocations?: Maybe<Array<Maybe<(
    { __typename?: 'AdminDeliveryLocation' }
    & Pick<AdminDeliveryLocation, 'id' | 'companyId'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'DeliveryLocationDetails' }
      & Pick<DeliveryLocationDetails, 'id' | 'name' | 'description'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
      )> }
    )>>>, timeSlots?: Maybe<Array<Maybe<(
      { __typename?: 'AdminDeliveryLocationTimeSlot' }
      & Pick<AdminDeliveryLocationTimeSlot, 'id' | 'time' | 'hour' | 'minute' | 'timeDurationBeforeOrderPlacement' | 'timeDurationBeforeOrderPlacementHour' | 'timeDurationBeforeOrderPlacementMinute' | 'timeDurationBeforeOrderToCancel' | 'timeDurationBeforeOrderToCancelHour' | 'timeDurationBeforeOrderToCancelMinute' | 'companyDeliveryLocationId'>
    )>>> }
  )>>>, companies?: Maybe<Array<Maybe<(
    { __typename?: 'AdminCompany' }
    & Pick<AdminCompany, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'CompanyDetails' }
      & Pick<CompanyDetails, 'name' | 'description'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
      )> }
    )>>>, deliveryLocations?: Maybe<Array<Maybe<(
      { __typename?: 'CompanyDeliveryLocation' }
      & Pick<CompanyDeliveryLocation, 'id'>
      & { details?: Maybe<Array<Maybe<(
        { __typename?: 'DeliveryLocationDetails' }
        & Pick<DeliveryLocationDetails, 'id' | 'name' | 'description'>
        & { language?: Maybe<(
          { __typename?: 'Language' }
          & Pick<Language, 'id' | 'name' | 'code' | 'englishName'>
        )> }
      )>>> }
    )>>> }
  )>>>, currency?: Maybe<(
    { __typename?: 'Currency' }
    & Pick<Currency, 'id' | 'name' | 'symbol' | 'shortName'>
  )>, details?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantDetails' }
    & Pick<RestaurantDetails, 'id' | 'name' | 'description' | 'imageUrl'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
    )> }
  )>>>, commisionDetails?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantCommisionDetails' }
    & Pick<RestaurantCommisionDetails, 'restaurantId' | 'companyId' | 'commisionAmount'>
  )>>>, settings?: Maybe<(
    { __typename?: 'RestaurantSettingsAdmin' }
    & Pick<RestaurantSettingsAdmin, 'ratingEmailAddress' | 'complaintEmailAddress' | 'provisionForCompanyPercentage' | 'provisionPercentage'>
  )> }
);

export type AdminDeliveryLocationTimeSlotFragment = (
  { __typename?: 'AdminDeliveryLocationTimeSlot' }
  & Pick<AdminDeliveryLocationTimeSlot, 'id' | 'time' | 'hour' | 'minute' | 'timeDurationBeforeOrderPlacement' | 'timeDurationBeforeOrderPlacementHour' | 'timeDurationBeforeOrderPlacementMinute' | 'timeDurationBeforeOrderToCancel' | 'timeDurationBeforeOrderToCancelHour' | 'timeDurationBeforeOrderToCancelMinute' | 'companyDeliveryLocationId'>
);

export type RestaurantCompaniesWithStatsFragment = (
  { __typename?: 'CompanyWithStats' }
  & Pick<CompanyWithStats, 'id' | 'percentageOfAllOrders' | 'totalAmount' | 'totalOrdersCount'>
  & { details?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyDetails' }
    & Pick<CompanyDetails, 'name' | 'description' | 'bannerImageUrl' | 'thumbnailUrl'>
    & { language?: Maybe<(
      { __typename?: 'Language' }
      & Pick<Language, 'id' | 'name' | 'englishName' | 'code'>
    )> }
  )>>>, currency?: Maybe<(
    { __typename?: 'Currency' }
    & Pick<Currency, 'id' | 'name' | 'symbol' | 'shortName'>
  )> }
);

export type EmpioyeeOrderComplaintForListFragment = (
  { __typename?: 'EmpioyeeOrderComplaintForList' }
  & Pick<EmpioyeeOrderComplaintForList, 'id' | 'createdAt' | 'isEmailSent' | 'complaintType' | 'complaintText' | 'dishName'>
  & { companyEmployee?: Maybe<(
    { __typename?: 'CompanyEmployee' }
    & Pick<CompanyEmployee, 'name' | 'surname' | 'email'>
  )> }
);

export type DeleteEmployeeMutationVariables = Exact<{
  id: Scalars['Long'];
  companyId: Scalars['Long'];
}>;


export type DeleteEmployeeMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteEmployee'>
);

export type CreateEmployeeGroupMutationVariables = Exact<{
  group?: Maybe<CompanyEmployeeGroupInput>;
  companyId: Scalars['Long'];
}>;


export type CreateEmployeeGroupMutation = (
  { __typename?: 'AppMutation' }
  & { createEmployeeGroup?: Maybe<(
    { __typename?: 'CompanyEmployeeGroup' }
    & CompanyEmployeeGroupFragment
  )> }
);

export type UpdateEmployeeGroupMutationVariables = Exact<{
  group?: Maybe<CompanyEmployeeGroupInput>;
  companyId: Scalars['Long'];
}>;


export type UpdateEmployeeGroupMutation = (
  { __typename?: 'AppMutation' }
  & { updateEmployeeGroup?: Maybe<(
    { __typename?: 'CompanyEmployeeGroup' }
    & CompanyEmployeeGroupFragment
  )> }
);

export type CreateEmployeeMutationVariables = Exact<{
  employee?: Maybe<CompanyEmployeeWithSubsidyAmountInput>;
  companyId: Scalars['Long'];
}>;


export type CreateEmployeeMutation = (
  { __typename?: 'AppMutation' }
  & { createEmployee?: Maybe<(
    { __typename?: 'CompanyEmployee' }
    & CompanyEmployeeEditFragment
  )> }
);

export type UpdateEmployeeMutationVariables = Exact<{
  employee?: Maybe<CompanyEmployeeWithSubsidyAmountInput>;
  companyId: Scalars['Long'];
}>;


export type UpdateEmployeeMutation = (
  { __typename?: 'AppMutation' }
  & { updateEmployee?: Maybe<(
    { __typename?: 'CompanyEmployee' }
    & CompanyEmployeeEditFragment
  )> }
);

export type DeleteEmployeeGroupMutationVariables = Exact<{
  id: Scalars['Long'];
  companyId: Scalars['Long'];
}>;


export type DeleteEmployeeGroupMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteEmployeeGroup'>
);

export type ResetEmployeePasswordMutationVariables = Exact<{
  employeeId: Scalars['Long'];
  companyId: Scalars['Long'];
}>;


export type ResetEmployeePasswordMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'resetEmployeePassword'>
);

export type CreateEmployeesFromExcelMutationVariables = Exact<{
  excelContent: Scalars['String'];
  companyId: Scalars['Long'];
}>;


export type CreateEmployeesFromExcelMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'createEmployeesFromExcel'>
);

export type AddDishTemplateMutationVariables = Exact<{
  menuDishTemplate?: Maybe<RestaurantDishTemplateInput>;
  restaurantId: Scalars['Long'];
}>;


export type AddDishTemplateMutation = (
  { __typename?: 'AppMutation' }
  & { addDishTemplate?: Maybe<(
    { __typename?: 'RestaurantDishTemplate' }
    & RestaurantDishTemplateFragment
  )> }
);

export type UpdateDishTemplateMutationVariables = Exact<{
  menuDishTemplate?: Maybe<RestaurantDishTemplateInput>;
  restaurantId: Scalars['Long'];
}>;


export type UpdateDishTemplateMutation = (
  { __typename?: 'AppMutation' }
  & { updateDishTemplate?: Maybe<(
    { __typename?: 'RestaurantDishTemplate' }
    & RestaurantDishTemplateFragment
  )> }
);

export type DeleteDishTemplateMutationVariables = Exact<{
  id: Scalars['Long'];
  restaurantId: Scalars['Long'];
}>;


export type DeleteDishTemplateMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteDishTemplate'>
);

export type AddMenuEntryMutationVariables = Exact<{
  menuEntry?: Maybe<RestaurantMenuEntryInput>;
  menuId?: Maybe<Scalars['Long']>;
  menuStartDay?: Maybe<Scalars['DateTime']>;
  menuEndDay?: Maybe<Scalars['DateTime']>;
  restaurantId: Scalars['Long'];
  addAsTemplate: Scalars['Boolean'];
}>;


export type AddMenuEntryMutation = (
  { __typename?: 'AppMutation' }
  & { addRestaurantMenuEntry?: Maybe<(
    { __typename?: 'RestaurantMenuEntry' }
    & RestaurantMenuEntryFragment
  )> }
);

export type UpdateMenuEntryMutationVariables = Exact<{
  menuEntry?: Maybe<RestaurantMenuEntryInput>;
  restaurantId: Scalars['Long'];
}>;


export type UpdateMenuEntryMutation = (
  { __typename?: 'AppMutation' }
  & { updateRestaurantMenuEntry?: Maybe<(
    { __typename?: 'RestaurantMenuEntry' }
    & RestaurantMenuEntryFragment
  )> }
);

export type DeleteMenuEntryMutationVariables = Exact<{
  id: Scalars['Long'];
  restaurantId: Scalars['Long'];
}>;


export type DeleteMenuEntryMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteRestaurantMenuEntry'>
);

export type ToggleHideMenuEntryMutationVariables = Exact<{
  id: Scalars['Long'];
  restaurantId: Scalars['Long'];
}>;


export type ToggleHideMenuEntryMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'toggleHideRestaurantMenuEntry'>
);

export type CopyLastWeekMenuMutationVariables = Exact<{
  menuStartDay: Scalars['DateTime'];
  menuEndDay: Scalars['DateTime'];
  restaurantId: Scalars['Long'];
}>;


export type CopyLastWeekMenuMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'copyLastWeekMenu'>
);

export type CopySelectedWeekMenuMutationVariables = Exact<{
  sourceMenuStartDay: Scalars['DateTime'];
  sourceMenuEndDay: Scalars['DateTime'];
  destMenuStartDay: Scalars['DateTime'];
  destMenuEndDay: Scalars['DateTime'];
  restaurantId: Scalars['Long'];
}>;


export type CopySelectedWeekMenuMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'copySelectedWeekMenu'>
);

export type CreateCompanyMutationVariables = Exact<{
  company?: Maybe<AdminCompanyInput>;
}>;


export type CreateCompanyMutation = (
  { __typename?: 'AppMutation' }
  & { createCompany?: Maybe<(
    { __typename?: 'AdminCompany' }
    & AdminCompanyFragment
  )> }
);

export type UpdateCompanyMutationVariables = Exact<{
  company?: Maybe<AdminCompanyInput>;
}>;


export type UpdateCompanyMutation = (
  { __typename?: 'AppMutation' }
  & { updateCompany?: Maybe<(
    { __typename?: 'AdminCompany' }
    & AdminCompanyFragment
  )> }
);

export type DeleteCompanyMutationVariables = Exact<{
  companyId: Scalars['Long'];
}>;


export type DeleteCompanyMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteCompany'>
);

export type CreateCompanyOwnerMutationVariables = Exact<{
  companyOwner?: Maybe<AdminCompanyOwnerInput>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
  companyId: Scalars['Long'];
}>;


export type CreateCompanyOwnerMutation = (
  { __typename?: 'AppMutation' }
  & { createCompanyOwner?: Maybe<(
    { __typename?: 'AdminCompanyOwner' }
    & AdminCompanyOwnerFragment
  )> }
);

export type UpdateCompanyOwnerMutationVariables = Exact<{
  companyOwner?: Maybe<AdminCompanyOwnerInput>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
}>;


export type UpdateCompanyOwnerMutation = (
  { __typename?: 'AppMutation' }
  & { updateCompanyOwner?: Maybe<(
    { __typename?: 'AdminCompanyOwner' }
    & AdminCompanyOwnerFragment
  )> }
);

export type DeleteCompanyOwnerMutationVariables = Exact<{
  ownerId: Scalars['Long'];
}>;


export type DeleteCompanyOwnerMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteCompanyOwner'>
);

export type CreateRestaurantMutationVariables = Exact<{
  restaurant?: Maybe<SuperAdminRestaurantInput>;
}>;


export type CreateRestaurantMutation = (
  { __typename?: 'AppMutation' }
  & { createRestaurant?: Maybe<(
    { __typename?: 'SuperAdminRestaurant' }
    & SuperAdminRestaurantFragment
  )> }
);

export type UpdateRestaurantMutationVariables = Exact<{
  restaurant?: Maybe<SuperAdminRestaurantInput>;
}>;


export type UpdateRestaurantMutation = (
  { __typename?: 'AppMutation' }
  & { updateRestaurant?: Maybe<(
    { __typename?: 'SuperAdminRestaurant' }
    & SuperAdminRestaurantFragment
  )> }
);

export type DeleteRestaurantMutationVariables = Exact<{
  restaurantId: Scalars['Long'];
}>;


export type DeleteRestaurantMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteRestaurant'>
);

export type CreateRestaurantOwnerMutationVariables = Exact<{
  restaurantOwner?: Maybe<AdminRestaurantOwnerInput>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
  restaurantId: Scalars['Long'];
}>;


export type CreateRestaurantOwnerMutation = (
  { __typename?: 'AppMutation' }
  & { createRestaurantOwner?: Maybe<(
    { __typename?: 'AdminRestaurantOwner' }
    & AdminRestaurantOwnerFragment
  )> }
);

export type UpdateRestaurantOwnerMutationVariables = Exact<{
  restaurantOwner?: Maybe<AdminRestaurantOwnerInput>;
  password?: Maybe<Scalars['String']>;
  passwordRepeat?: Maybe<Scalars['String']>;
}>;


export type UpdateRestaurantOwnerMutation = (
  { __typename?: 'AppMutation' }
  & { updateRestaurantOwner?: Maybe<(
    { __typename?: 'AdminRestaurantOwner' }
    & AdminRestaurantOwnerFragment
  )> }
);

export type DeleteRestaurantOwnerMutationVariables = Exact<{
  ownerId: Scalars['Long'];
}>;


export type DeleteRestaurantOwnerMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteRestaurantOwner'>
);

export type AddCompanyToRestaurantMutationVariables = Exact<{
  companyId: Scalars['Long'];
  restaurantId: Scalars['Long'];
}>;


export type AddCompanyToRestaurantMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'addCompanyToRestaurant'>
);

export type RemoveCompanyFromRestaurantMutationVariables = Exact<{
  companyId: Scalars['Long'];
  restaurantId: Scalars['Long'];
}>;


export type RemoveCompanyFromRestaurantMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'removeCompanyFromRestaurant'>
);

export type CreateRestaurantCompanyTimeslotMutationVariables = Exact<{
  deliveryLocationTimeSlot?: Maybe<AdminDeliveryLocationTimeSlotInput>;
  companyDeliveryLocationId: Scalars['Long'];
  restaurantId: Scalars['Long'];
}>;


export type CreateRestaurantCompanyTimeslotMutation = (
  { __typename?: 'AppMutation' }
  & { createRestaurantCompanyTimeslot?: Maybe<(
    { __typename?: 'AdminDeliveryLocationTimeSlot' }
    & AdminDeliveryLocationTimeSlotFragment
  )> }
);

export type EditRestaurantCompanyTimeslotMutationVariables = Exact<{
  deliveryLocationTimeSlot?: Maybe<AdminDeliveryLocationTimeSlotInput>;
}>;


export type EditRestaurantCompanyTimeslotMutation = (
  { __typename?: 'AppMutation' }
  & { editRestaurantCompanyTimeslot?: Maybe<(
    { __typename?: 'AdminDeliveryLocationTimeSlot' }
    & AdminDeliveryLocationTimeSlotFragment
  )> }
);

export type DeleteRestaurantCompanyTimeslotMutationVariables = Exact<{
  timeslotId: Scalars['Long'];
}>;


export type DeleteRestaurantCompanyTimeslotMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteRestaurantCompanyTimeslot'>
);

export type CreateDeliveryLocationMutationVariables = Exact<{
  deliveryLocation?: Maybe<CompanyDeliveryLocationInput>;
  companyId: Scalars['Long'];
}>;


export type CreateDeliveryLocationMutation = (
  { __typename?: 'AppMutation' }
  & { createDeliveryLocation?: Maybe<(
    { __typename?: 'CompanyDeliveryLocation' }
    & CompanyDeliveryLocationFragment
  )> }
);

export type UpdateDeliveryLocationMutationVariables = Exact<{
  deliveryLocation?: Maybe<CompanyDeliveryLocationInput>;
}>;


export type UpdateDeliveryLocationMutation = (
  { __typename?: 'AppMutation' }
  & { updateDeliveryLocation?: Maybe<(
    { __typename?: 'CompanyDeliveryLocation' }
    & CompanyDeliveryLocationFragment
  )> }
);

export type DelteDeliveryLocationMutationVariables = Exact<{
  deliveryLocationId: Scalars['Long'];
}>;


export type DelteDeliveryLocationMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteDeliveryLocation'>
);

export type UpdateMenuCategoryMutationVariables = Exact<{
  menuCategory?: Maybe<RestaurantMenuCategoryInput>;
}>;


export type UpdateMenuCategoryMutation = (
  { __typename?: 'AppMutation' }
  & { updateMenuCategory?: Maybe<(
    { __typename?: 'RestaurantMenuCategory' }
    & RestaurantMenuCategoryFragment
  )> }
);

export type CreateMenuCategoryMutationVariables = Exact<{
  menuCategory?: Maybe<RestaurantMenuCategoryInput>;
}>;


export type CreateMenuCategoryMutation = (
  { __typename?: 'AppMutation' }
  & { createMenuCategory?: Maybe<(
    { __typename?: 'RestaurantMenuCategory' }
    & RestaurantMenuCategoryFragment
  )> }
);

export type DeleteMenuCategoryMutationVariables = Exact<{
  id: Scalars['Long'];
}>;


export type DeleteMenuCategoryMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteMenuCategory'>
);

export type UpdateDishAllergenMutationVariables = Exact<{
  dishAllergen?: Maybe<DishAllergeneInput>;
}>;


export type UpdateDishAllergenMutation = (
  { __typename?: 'AppMutation' }
  & { updateDishAllergen?: Maybe<(
    { __typename?: 'DishAllergene' }
    & DishAllergeneFragment
  )> }
);

export type CreateDishAllergenMutationVariables = Exact<{
  dishAllergen?: Maybe<DishAllergeneInput>;
}>;


export type CreateDishAllergenMutation = (
  { __typename?: 'AppMutation' }
  & { createDishAllergen?: Maybe<(
    { __typename?: 'DishAllergene' }
    & DishAllergeneFragment
  )> }
);

export type DeleteDishAllergenMutationVariables = Exact<{
  id: Scalars['Long'];
}>;


export type DeleteDishAllergenMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'deleteDishAllergen'>
);

export type UpdateUserMutationVariables = Exact<{
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
}>;


export type UpdateUserMutation = (
  { __typename?: 'AppMutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'LunchAppUserEntity' }
    & Pick<LunchAppUserEntity, 'id'>
  )> }
);

export type ConsumePasswordResetTokenMutationVariables = Exact<{
  email?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  newPassword?: Maybe<Scalars['String']>;
}>;


export type ConsumePasswordResetTokenMutation = (
  { __typename?: 'AppMutation' }
  & Pick<AppMutation, 'consumePasswordResetToken'>
);

export type LoginQueryVariables = Exact<{
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
}>;


export type LoginQuery = (
  { __typename?: 'AppQuery' }
  & { login?: Maybe<(
    { __typename?: 'TokenResponse' }
    & Pick<TokenResponse, 'id' | 'accessToken' | 'refreshToken' | 'accessTokenExpirationDate' | 'refreshTokenExpirationDate' | 'roles'>
  )> }
);

export type RefreshAccessTokenQueryVariables = Exact<{
  refreshToken?: Maybe<Scalars['String']>;
}>;


export type RefreshAccessTokenQuery = (
  { __typename?: 'AppQuery' }
  & { refreshAccessToken?: Maybe<(
    { __typename?: 'TokenResponse' }
    & Pick<TokenResponse, 'id' | 'accessToken' | 'refreshToken' | 'accessTokenExpirationDate' | 'refreshTokenExpirationDate' | 'roles'>
  )> }
);

export type GetCurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenciesQuery = (
  { __typename?: 'AppQuery' }
  & { currencies?: Maybe<Array<Maybe<(
    { __typename?: 'Currency' }
    & CurrencyFragment
  )>>> }
);

export type GetDefaultCompanyWithDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultCompanyWithDetailsQuery = (
  { __typename?: 'AppQuery' }
  & { defaultCompanyWithDetails?: Maybe<(
    { __typename?: 'AdminCompany' }
    & AdminCompanyFragment
  )> }
);

export type GetCompanyOrdersStatisticsQueryVariables = Exact<{
  companyId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetCompanyOrdersStatisticsQuery = (
  { __typename?: 'AppQuery' }
  & { companyOrdersStatistics?: Maybe<(
    { __typename?: 'CompanyOrdersStatistics' }
    & CompanyOrdersStatisticsFragment
  )> }
);

export type GetCompanyEmployeesWithoutOrdersQueryVariables = Exact<{
  companyId: Scalars['Long'];
}>;


export type GetCompanyEmployeesWithoutOrdersQuery = (
  { __typename?: 'AppQuery' }
  & { companyEmployeesWithoutOrders?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyEmployeeWithSubsidyAmount' }
    & CompanyEmployeeWithSubsidyAmountFragment
  )>>> }
);

export type GetCompanyBasicStatsQueryVariables = Exact<{
  companyId: Scalars['Long'];
}>;


export type GetCompanyBasicStatsQuery = (
  { __typename?: 'AppQuery' }
  & { companyBasicStats?: Maybe<(
    { __typename?: 'CompanyBasicStats' }
    & CompanyBasicStatsFragment
  )> }
);

export type GetCompanyRestaurantsQueryVariables = Exact<{
  companyId: Scalars['Long'];
}>;


export type GetCompanyRestaurantsQuery = (
  { __typename?: 'AppQuery' }
  & { companyRestaurants?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantWithStats' }
    & RestaurantWithStatsFragment
  )>>> }
);

export type GetRestaurantOrdersStatisticsQueryVariables = Exact<{
  companyId: Scalars['Long'];
  restaurantId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetRestaurantOrdersStatisticsQuery = (
  { __typename?: 'AppQuery' }
  & { restaurantOrdersStatistics?: Maybe<(
    { __typename?: 'RestaurantOrdersStatistics' }
    & RestaurantOrdersStatisticsFragment
  )> }
);

export type GetCompanyAllEmployeesQueryVariables = Exact<{
  companyId: Scalars['Long'];
}>;


export type GetCompanyAllEmployeesQuery = (
  { __typename?: 'AppQuery' }
  & { companyAllEmployees?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyEmployeeWithSubsidyAmount' }
    & CompanyEmployeeWithSubsidyAmountFragment
  )>>> }
);

export type GetEmployeeOrdersStatisticsQueryVariables = Exact<{
  companyId: Scalars['Long'];
  employeeId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetEmployeeOrdersStatisticsQuery = (
  { __typename?: 'AppQuery' }
  & { employeeOrdersStatistics?: Maybe<(
    { __typename?: 'EmployeeOrdersStatistics' }
    & EmployeeOrdersStatisticsFragment
  )> }
);

export type GetCompanyEmployeesGroupsQueryVariables = Exact<{
  companyId: Scalars['Long'];
}>;


export type GetCompanyEmployeesGroupsQuery = (
  { __typename?: 'AppQuery' }
  & { companyEmployeesGroups?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyEmployeeGroup' }
    & CompanyEmployeeGroupFragment
  )>>> }
);

export type GetEmployeeGroupOrdersStatisticsQueryVariables = Exact<{
  companyId: Scalars['Long'];
  groupId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetEmployeeGroupOrdersStatisticsQuery = (
  { __typename?: 'AppQuery' }
  & { employeeGroupOrdersStatistics?: Maybe<(
    { __typename?: 'EmployeeGroupOrdersStatistics' }
    & EmployeeGroupOrdersStatisticsFragment
  )> }
);

export type GetDefaultAdminRestaurantWithDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultAdminRestaurantWithDetailsQuery = (
  { __typename?: 'AppQuery' }
  & { defaultRestaurantWithDetails?: Maybe<(
    { __typename?: 'AdminRestaurant' }
    & Pick<AdminRestaurant, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'RestaurantDetails' }
      & Pick<RestaurantDetails, 'id' | 'name' | 'imageUrl'>
    )>>>, companies?: Maybe<Array<Maybe<(
      { __typename?: 'Company' }
      & Pick<Company, 'id'>
      & { details?: Maybe<Array<Maybe<(
        { __typename?: 'CompanyDetails' }
        & Pick<CompanyDetails, 'name'>
        & { language?: Maybe<(
          { __typename?: 'Language' }
          & Pick<Language, 'code'>
        )> }
      )>>> }
    )>>>, deliveryLocations?: Maybe<Array<Maybe<(
      { __typename?: 'DeliveryLocation' }
      & Pick<DeliveryLocation, 'id' | 'lat' | 'lon'>
      & { timeSlots?: Maybe<Array<Maybe<(
        { __typename?: 'DeliveryLocationTimeSlot' }
        & Pick<DeliveryLocationTimeSlot, 'id' | 'time' | 'hour' | 'minute'>
      )>>>, details?: Maybe<Array<Maybe<(
        { __typename?: 'DeliveryLocationDetails' }
        & Pick<DeliveryLocationDetails, 'id' | 'name'>
        & { language?: Maybe<(
          { __typename?: 'Language' }
          & Pick<Language, 'code'>
        )> }
      )>>> }
    )>>>, settings?: Maybe<(
      { __typename?: 'RestaurantSettingsAdmin' }
      & Pick<RestaurantSettingsAdmin, 'id' | 'defaultDishOfTheDayPrice' | 'testMode' | 'provisionPercentage' | 'provisionForCompanyPercentage'>
    )> }
  )> }
);

export type GetHistoricalRestaurantOrdersQueryVariables = Exact<{
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  deliveryLocationIds?: Maybe<Array<Scalars['Long']> | Scalars['Long']>;
  companyIds?: Maybe<Array<Scalars['Long']> | Scalars['Long']>;
  restaurantId: Scalars['Long'];
}>;


export type GetHistoricalRestaurantOrdersQuery = (
  { __typename?: 'AppQuery' }
  & { restaurantOrders?: Maybe<Array<Maybe<(
    { __typename?: 'EmployeeOrder' }
    & EmployeeOrderForTableFragment
  )>>> }
);

export type GetCurrentRestaurantOrdersQueryVariables = Exact<{
  startDateTime: Scalars['DateTime'];
  endDateTime: Scalars['DateTime'];
  deliveryLocationIds?: Maybe<Array<Scalars['Long']> | Scalars['Long']>;
  companyIds?: Maybe<Array<Scalars['Long']> | Scalars['Long']>;
  restaurantId: Scalars['Long'];
}>;


export type GetCurrentRestaurantOrdersQuery = (
  { __typename?: 'AppQuery' }
  & { currentRestaurantOrders?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantCurrentOrder' }
    & RestaurantCurrentOrderFragment
  )>>> }
);

export type GetRestaurantDishTemplatesQueryVariables = Exact<{
  restaurantId: Scalars['Long'];
}>;


export type GetRestaurantDishTemplatesQuery = (
  { __typename?: 'AppQuery' }
  & { allDishTemplates?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantDishTemplate' }
    & RestaurantDishTemplateFragment
  )>>> }
);

export type GetRestaurantMenuQueryVariables = Exact<{
  dayInWeek: Scalars['DateTime'];
  restaurantId: Scalars['Long'];
}>;


export type GetRestaurantMenuQuery = (
  { __typename?: 'AppQuery' }
  & { menuForWeek?: Maybe<(
    { __typename?: 'RestaurantMenu' }
    & RestaurantMenuFragment
  )> }
);

export type GetDishAllergensQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDishAllergensQuery = (
  { __typename?: 'AppQuery' }
  & { dishAllergens?: Maybe<Array<Maybe<(
    { __typename?: 'DishAllergene' }
    & Pick<DishAllergene, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'DishAllergeneDetails' }
      & Pick<DishAllergeneDetails, 'id' | 'name'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )>>> }
);

export type GetMenuCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMenuCategoriesQuery = (
  { __typename?: 'AppQuery' }
  & { menuCattegories?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantMenuCategory' }
    & Pick<RestaurantMenuCategory, 'id'>
    & { details?: Maybe<Array<Maybe<(
      { __typename?: 'RestaurantMenuCategoryDetails' }
      & Pick<RestaurantMenuCategoryDetails, 'id' | 'categoryName'>
      & { language?: Maybe<(
        { __typename?: 'Language' }
        & Pick<Language, 'code'>
      )> }
    )>>> }
  )>>> }
);

export type GetBasicSettlementStatsQueryVariables = Exact<{
  restaurantId: Scalars['Long'];
}>;


export type GetBasicSettlementStatsQuery = (
  { __typename?: 'AppQuery' }
  & { basicSettlementStats?: Maybe<(
    { __typename?: 'RestaurantBasicSettlementAmount' }
    & RestaurantBasicSettlementAmountFragment
  )> }
);

export type GetOrdersStatsQueryVariables = Exact<{
  start: Scalars['DateTime'];
  end: Scalars['DateTime'];
  restaurantId: Scalars['Long'];
}>;


export type GetOrdersStatsQuery = (
  { __typename?: 'AppQuery' }
  & { ordersStats?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantDeliveryCount' }
    & RestaurantDeliveryCountFragment
  )>>> }
);

export type GetRestaurantInvoicesQueryVariables = Exact<{
  restaurantId: Scalars['Long'];
}>;


export type GetRestaurantInvoicesQuery = (
  { __typename?: 'AppQuery' }
  & { restaurantInvoices?: Maybe<Array<Maybe<(
    { __typename?: 'RestaurantInvoice' }
    & RestaurantInvoiceFragment
  )>>> }
);

export type GetRestaurantFinishedOrdersStatisticsQueryVariables = Exact<{
  restaurantId: Scalars['Long'];
  companyId?: Maybe<Scalars['Long']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetRestaurantFinishedOrdersStatisticsQuery = (
  { __typename?: 'AppQuery' }
  & { restaurantFinishedOrdersStatistics?: Maybe<(
    { __typename?: 'RestaurantFinishedOrdersStatistics' }
    & RestaurantFinishedOrdersStatisticsFragment
  )> }
);

export type GetRestaurantCompaniesQueryVariables = Exact<{
  restaurantId: Scalars['Long'];
}>;


export type GetRestaurantCompaniesQuery = (
  { __typename?: 'AppQuery' }
  & { restaurantCompanies?: Maybe<Array<Maybe<(
    { __typename?: 'CompanyWithStats' }
    & RestaurantCompaniesWithStatsFragment
  )>>> }
);

export type GetRestaurantCompanyOrdersStatisticsQueryVariables = Exact<{
  companyId: Scalars['Long'];
  restaurantId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetRestaurantCompanyOrdersStatisticsQuery = (
  { __typename?: 'AppQuery' }
  & { restaurantCompanyOrdersStatistics?: Maybe<(
    { __typename?: 'CompanyOrdersStatistics' }
    & CompanyOrdersStatisticsFragment
  )> }
);

export type GetRestaurantComplaintsQueryVariables = Exact<{
  restaurantId: Scalars['Long'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetRestaurantComplaintsQuery = (
  { __typename?: 'AppQuery' }
  & { restaurantComplaints?: Maybe<Array<Maybe<(
    { __typename?: 'EmpioyeeOrderComplaintForList' }
    & EmpioyeeOrderComplaintForListFragment
  )>>> }
);

export type GetAdminCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminCompaniesQuery = (
  { __typename?: 'AppQuery' }
  & { adminCompanies?: Maybe<Array<Maybe<(
    { __typename?: 'SuperAdminCompany' }
    & SuperAdminCompanyFragment
  )>>> }
);

export type GetAdminRestaurantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminRestaurantsQuery = (
  { __typename?: 'AppQuery' }
  & { adminRestaurants?: Maybe<Array<Maybe<(
    { __typename?: 'SuperAdminRestaurant' }
    & SuperAdminRestaurantFragment
  )>>> }
);

export const CompanyEmployeeGroupFragmentDoc = gql`
    fragment CompanyEmployeeGroup on CompanyEmployeeGroup {
  id
  name
  subsidy {
    subsidyPercentage
    subsidyAmount
    dailySubsidyLimit
    monthlyAmountLimit
    dailyAmountLimit
    isOverSubsidyPaidByCompany
  }
}
    `;
export const CurrencyFragmentDoc = gql`
    fragment Currency on Currency {
  id
  name
  symbol
  shortName
}
    `;
export const RestaurantMenuCategoryFragmentDoc = gql`
    fragment RestaurantMenuCategory on RestaurantMenuCategory {
  id
  details {
    id
    language {
      id
      code
    }
    categoryName
  }
}
    `;
export const DishAllergeneFragmentDoc = gql`
    fragment DishAllergene on DishAllergene {
  id
  details {
    id
    language {
      id
      code
    }
    name
  }
}
    `;
export const AdminCompanyFragmentDoc = gql`
    fragment AdminCompany on AdminCompany {
  id
  details {
    name
    description
    bannerImageUrl
  }
  restaurants {
    id
    details {
      id
      name
      description
      imageUrl
    }
  }
  employeeGroups {
    id
    name
    subsidy {
      subsidyPercentage
      subsidyAmount
      dailySubsidyLimit
      monthlyAmountLimit
      dailyAmountLimit
      isOverSubsidyPaidByCompany
    }
  }
}
    `;
export const SuperAdminCompanyFragmentDoc = gql`
    fragment SuperAdminCompany on SuperAdminCompany {
  id
  owners {
    id
    username
    email
    authId
  }
  details {
    language {
      id
      name
      englishName
      code
    }
    name
    description
    bannerImageUrl
    thumbnailUrl
  }
  restaurants {
    id
    currency {
      id
      name
      symbol
      shortName
    }
    details {
      id
      language {
        id
        name
        englishName
        code
      }
      name
      description
      imageUrl
    }
  }
  deliveryLocations {
    id
    details {
      id
      name
      description
      imageUrl
      language {
        id
        name
        code
      }
    }
  }
}
    `;
export const AdminCompanyOwnerFragmentDoc = gql`
    fragment AdminCompanyOwner on AdminCompanyOwner {
  id
  username
  authId
  email
}
    `;
export const CompanyDeliveryLocationFragmentDoc = gql`
    fragment CompanyDeliveryLocation on CompanyDeliveryLocation {
  id
  details {
    id
    name
    description
    imageUrl
    language {
      id
      name
      englishName
      code
    }
  }
}
    `;
export const CompanyBasicStatsFragmentDoc = gql`
    fragment CompanyBasicStats on CompanyBasicStats {
  totalEmployeesCount
  totalGroupsCount
  thisWeekOrdersCount
  thisMonthOrdersCount
}
    `;
export const CompanyEmployeeEditFragmentDoc = gql`
    fragment CompanyEmployeeEdit on CompanyEmployee {
  id
  name
  surname
  email
  code
  employeeGroup {
    id
    name
  }
}
    `;
export const CompanyEmployeeWithSubsidyAmountFragmentDoc = gql`
    fragment CompanyEmployeeWithSubsidyAmount on CompanyEmployeeWithSubsidyAmount {
  id
  name
  surname
  totalAmount
  subsidizedAmount
  lastOrderDate
  lastOrderValue
  email
  code
  remainingSubsidy
  isDeactivated
  canMakeOrderFrom
  canMakeOrderTo
  lastDeactivationDate
  employeeGroup {
    id
    name
    subsidy {
      subsidyPercentage
      subsidyAmount
      dailySubsidyLimit
      monthlyAmountLimit
      dailyAmountLimit
      isOverSubsidyPaidByCompany
    }
  }
}
    `;
export const CompanyOrdersStatisticsFragmentDoc = gql`
    fragment CompanyOrdersStatistics on CompanyOrdersStatistics {
  totalOrdersCount
  totalOrdersValue
  totalSubsidizedOrdersValue
  yearStatistics {
    key
    count
    amount
    subsidizedAmount
  }
  monthStatistics {
    key
    count
    amount
    subsidizedAmount
  }
  weekStatistics {
    key
    count
    amount
    subsidizedAmount
  }
}
    `;
export const RestaurantOrdersStatisticsFragmentDoc = gql`
    fragment RestaurantOrdersStatistics on RestaurantOrdersStatistics {
  totalOrdersCount
  totalOrdersValue
  totalSubsidizedOrdersValue
  yearStatistics {
    key
    count
    amount
    subsidizedAmount
  }
  monthStatistics {
    key
    count
    amount
    subsidizedAmount
  }
  weekStatistics {
    key
    count
    amount
    subsidizedAmount
  }
}
    `;
export const EmployeeOrdersStatisticsFragmentDoc = gql`
    fragment EmployeeOrdersStatistics on EmployeeOrdersStatistics {
  totalOrdersCount
  totalOrdersValue
  totalSubsidizedOrdersValue
  yearStatistics {
    key
    count
    amount
    subsidizedAmount
  }
  monthStatistics {
    key
    count
    amount
    subsidizedAmount
  }
  weekStatistics {
    key
    count
    amount
    subsidizedAmount
  }
}
    `;
export const EmployeeGroupOrdersStatisticsFragmentDoc = gql`
    fragment EmployeeGroupOrdersStatistics on EmployeeGroupOrdersStatistics {
  totalOrdersCount
  totalOrdersValue
  totalSubsidizedOrdersValue
  yearStatistics {
    key
    count
    amount
    subsidizedAmount
  }
  monthStatistics {
    key
    count
    amount
    subsidizedAmount
  }
  weekStatistics {
    key
    count
    amount
    subsidizedAmount
  }
}
    `;
export const RestaurantWithStatsFragmentDoc = gql`
    fragment RestaurantWithStats on RestaurantWithStats {
  id
  currency {
    id
    name
    symbol
    shortName
  }
  details {
    id
    language {
      id
      code
      name
    }
    name
    description
    imageUrl
  }
  stats {
    percentageOfAllOrders
  }
  totalAmount
  totalOrdersCount
  totalDishCount
}
    `;
export const RestaurantDishTemplateFragmentDoc = gql`
    fragment RestaurantDishTemplate on RestaurantDishTemplate {
  id
  price
  basePrice
  priceForRestaurant
  isAccepted
  details {
    title
    description
    imageUrl
    ingredients
    parts
    estimatedPreparationTime
    language {
      code
    }
  }
  categories {
    id
    details {
      id
      categoryName
      language {
        code
      }
    }
  }
  allergenes {
    id
    details {
      id
      name
      language {
        code
      }
    }
  }
  ratingPointsCount
  ratingPointsSum
}
    `;
export const RestaurantMenuEntryFragmentDoc = gql`
    fragment RestaurantMenuEntry on RestaurantMenuEntry {
  id
  price
  basePrice
  priceForRestaurant
  dishOfTheDayPrice
  entryOfTheDay
  entryOfTheDays
  details {
    id
    title
    description
    ingredients
    imageUrl
    estimatedPreparationTime
    language {
      id
      code
    }
  }
  stats {
    orderCount
    totalAmount
  }
  categories {
    id
    details {
      id
      language {
        id
        code
      }
      categoryName
    }
  }
  allergenes {
    id
    details {
      id
      name
      language {
        id
        code
      }
    }
  }
  isHidden
  isAccepted
  dishTemplate {
    ...RestaurantDishTemplate
  }
  ratingPointsCount
  ratingPointsSum
}
    ${RestaurantDishTemplateFragmentDoc}`;
export const EmployeeOrderForTableFragmentDoc = gql`
    fragment EmployeeOrderForTable on EmployeeOrder {
  id
  company {
    details {
      name
      language {
        code
      }
    }
  }
  deliveryLocation {
    details {
      name
      language {
        code
      }
    }
  }
  totalAmount
  amountToPayForRestaurant
  amountToPayBasePrice
  parentGroup {
    periodEnd
    ordersDeliveryDateTime
    companyEmployee {
      id
      name
      surname
    }
  }
  createDateTime
  menuEntry {
    ...RestaurantMenuEntry
  }
  isGivenOut
  giveOutDateTime
}
    ${RestaurantMenuEntryFragmentDoc}`;
export const RestaurantCurrentOrderFragmentDoc = gql`
    fragment RestaurantCurrentOrder on RestaurantCurrentOrder {
  id
  menuEntry {
    ...RestaurantMenuEntry
  }
  employee {
    name
    surname
  }
  totalAmount
  overPaidForRestaurant
  isGivenOut
  giveOutDateTime
  deliveryDateTime
  isStickerPrinted
  deliveryLocation {
    details {
      language {
        code
      }
      name
    }
  }
  company {
    details {
      language {
        code
      }
      name
    }
  }
}
    ${RestaurantMenuEntryFragmentDoc}`;
export const RestaurantMenuFragmentDoc = gql`
    fragment RestaurantMenu on RestaurantMenu {
  id
  menuStartDay
  menuEndDay
  entries {
    ...RestaurantMenuEntry
  }
}
    ${RestaurantMenuEntryFragmentDoc}`;
export const RestaurantInvoiceFragmentDoc = gql`
    fragment RestaurantInvoice on RestaurantInvoice {
  restaurantId
  issueData
  periodStart
  periodEnd
  ordersCount
  ordersValue
  calculatedValue
}
    `;
export const RestaurantDeliveryCountFragmentDoc = gql`
    fragment RestaurantDeliveryCount on RestaurantDeliveryCount {
  company {
    id
    details {
      name
      language {
        code
      }
    }
  }
  deliveryCount
  totalAmount
  toRealizeCount
  toRealizeAmount
}
    `;
export const RestaurantBasicSettlementAmountFragmentDoc = gql`
    fragment RestaurantBasicSettlementAmount on RestaurantBasicSettlementAmount {
  thisMonthValue
  prevMonthValue
  thisMonthTotalAmount
  prevMonthTotalAmount
}
    `;
export const RestaurantFinishedOrdersStatisticsFragmentDoc = gql`
    fragment RestaurantFinishedOrdersStatistics on RestaurantFinishedOrdersStatistics {
  totalOrdersCount
  totalOrdersValue
  totalFoodApkaOrdersValue
  yearStatistics {
    key
    count
    amount
    foodApkaAmount
  }
  monthStatistics {
    key
    count
    amount
    foodApkaAmount
  }
  weekStatistics {
    key
    count
    amount
    foodApkaAmount
  }
}
    `;
export const AdminRestaurantOwnerFragmentDoc = gql`
    fragment AdminRestaurantOwner on AdminRestaurantOwner {
  id
  username
  authId
  email
}
    `;
export const AdminRestaurantFragmentDoc = gql`
    fragment AdminRestaurant on AdminRestaurant {
  id
  owners {
    id
    username
  }
  deliveryLocations {
    id
    details {
      id
      name
      description
      language {
        id
        name
        englishName
        code
      }
    }
    timeSlots {
      id
      time
      hour
      minute
    }
  }
  companies {
    id
  }
  currency {
    id
    name
    symbol
    shortName
  }
  details {
    id
    name
    language {
      id
      name
      englishName
      code
    }
    description
    imageUrl
  }
  commisionDetails {
    restaurantId
    companyId
    commisionAmount
  }
  settings {
    paymentPosId
    paymentSalt
  }
}
    `;
export const SuperAdminRestaurantFragmentDoc = gql`
    fragment SuperAdminRestaurant on SuperAdminRestaurant {
  id
  owners {
    id
    username
    email
    authId
  }
  deliveryLocations {
    id
    companyId
    details {
      id
      name
      description
      language {
        id
        name
        englishName
        code
      }
    }
    timeSlots {
      id
      time
      hour
      minute
      timeDurationBeforeOrderPlacement
      timeDurationBeforeOrderPlacementHour
      timeDurationBeforeOrderPlacementMinute
      timeDurationBeforeOrderToCancel
      timeDurationBeforeOrderToCancelHour
      timeDurationBeforeOrderToCancelMinute
      companyDeliveryLocationId
    }
  }
  companies {
    id
    details {
      name
      description
      language {
        id
        name
        englishName
        code
      }
    }
    deliveryLocations {
      id
      details {
        id
        name
        description
        language {
          id
          name
          code
          englishName
        }
      }
    }
  }
  currency {
    id
    name
    symbol
    shortName
  }
  details {
    id
    name
    language {
      id
      name
      englishName
      code
    }
    description
    imageUrl
  }
  commisionDetails {
    restaurantId
    companyId
    commisionAmount
  }
  settings {
    ratingEmailAddress
    complaintEmailAddress
    provisionForCompanyPercentage
    provisionPercentage
  }
}
    `;
export const AdminDeliveryLocationTimeSlotFragmentDoc = gql`
    fragment AdminDeliveryLocationTimeSlot on AdminDeliveryLocationTimeSlot {
  id
  time
  hour
  minute
  timeDurationBeforeOrderPlacement
  timeDurationBeforeOrderPlacementHour
  timeDurationBeforeOrderPlacementMinute
  timeDurationBeforeOrderToCancel
  timeDurationBeforeOrderToCancelHour
  timeDurationBeforeOrderToCancelMinute
  companyDeliveryLocationId
}
    `;
export const RestaurantCompaniesWithStatsFragmentDoc = gql`
    fragment RestaurantCompaniesWithStats on CompanyWithStats {
  id
  details {
    language {
      id
      name
      englishName
      code
    }
    name
    description
    bannerImageUrl
    thumbnailUrl
  }
  currency {
    id
    name
    symbol
    shortName
  }
  percentageOfAllOrders
  totalAmount
  totalOrdersCount
}
    `;
export const EmpioyeeOrderComplaintForListFragmentDoc = gql`
    fragment EmpioyeeOrderComplaintForList on EmpioyeeOrderComplaintForList {
  id
  createdAt
  isEmailSent
  complaintType
  complaintText
  dishName
  companyEmployee {
    name
    surname
    email
  }
}
    `;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($id: Long!, $companyId: Long!) {
  deleteEmployee(employeeId: $id, companyId: $companyId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEmployeeGQL extends Apollo.Mutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables> {
    document = DeleteEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEmployeeGroupDocument = gql`
    mutation CreateEmployeeGroup($group: CompanyEmployeeGroupInput, $companyId: Long!) {
  createEmployeeGroup(group: $group, companyId: $companyId) {
    ...CompanyEmployeeGroup
  }
}
    ${CompanyEmployeeGroupFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEmployeeGroupGQL extends Apollo.Mutation<CreateEmployeeGroupMutation, CreateEmployeeGroupMutationVariables> {
    document = CreateEmployeeGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmployeeGroupDocument = gql`
    mutation UpdateEmployeeGroup($group: CompanyEmployeeGroupInput, $companyId: Long!) {
  updateEmployeeGroup(group: $group, companyId: $companyId) {
    ...CompanyEmployeeGroup
  }
}
    ${CompanyEmployeeGroupFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmployeeGroupGQL extends Apollo.Mutation<UpdateEmployeeGroupMutation, UpdateEmployeeGroupMutationVariables> {
    document = UpdateEmployeeGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($employee: CompanyEmployeeWithSubsidyAmountInput, $companyId: Long!) {
  createEmployee(employee: $employee, companyId: $companyId) {
    ...CompanyEmployeeEdit
  }
}
    ${CompanyEmployeeEditFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEmployeeGQL extends Apollo.Mutation<CreateEmployeeMutation, CreateEmployeeMutationVariables> {
    document = CreateEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($employee: CompanyEmployeeWithSubsidyAmountInput, $companyId: Long!) {
  updateEmployee(employee: $employee, companyId: $companyId) {
    ...CompanyEmployeeEdit
  }
}
    ${CompanyEmployeeEditFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateEmployeeGQL extends Apollo.Mutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables> {
    document = UpdateEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEmployeeGroupDocument = gql`
    mutation DeleteEmployeeGroup($id: Long!, $companyId: Long!) {
  deleteEmployeeGroup(groupId: $id, companyId: $companyId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEmployeeGroupGQL extends Apollo.Mutation<DeleteEmployeeGroupMutation, DeleteEmployeeGroupMutationVariables> {
    document = DeleteEmployeeGroupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetEmployeePasswordDocument = gql`
    mutation ResetEmployeePassword($employeeId: Long!, $companyId: Long!) {
  resetEmployeePassword(employeeId: $employeeId, companyId: $companyId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetEmployeePasswordGQL extends Apollo.Mutation<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables> {
    document = ResetEmployeePasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEmployeesFromExcelDocument = gql`
    mutation CreateEmployeesFromExcel($excelContent: String!, $companyId: Long!) {
  createEmployeesFromExcel(excelContent: $excelContent, companyId: $companyId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEmployeesFromExcelGQL extends Apollo.Mutation<CreateEmployeesFromExcelMutation, CreateEmployeesFromExcelMutationVariables> {
    document = CreateEmployeesFromExcelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddDishTemplateDocument = gql`
    mutation AddDishTemplate($menuDishTemplate: RestaurantDishTemplateInput, $restaurantId: Long!) {
  addDishTemplate(dishTemplate: $menuDishTemplate, restaurantId: $restaurantId) {
    ...RestaurantDishTemplate
  }
}
    ${RestaurantDishTemplateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddDishTemplateGQL extends Apollo.Mutation<AddDishTemplateMutation, AddDishTemplateMutationVariables> {
    document = AddDishTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDishTemplateDocument = gql`
    mutation UpdateDishTemplate($menuDishTemplate: RestaurantDishTemplateInput, $restaurantId: Long!) {
  updateDishTemplate(dishTemplate: $menuDishTemplate, restaurantId: $restaurantId) {
    ...RestaurantDishTemplate
  }
}
    ${RestaurantDishTemplateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDishTemplateGQL extends Apollo.Mutation<UpdateDishTemplateMutation, UpdateDishTemplateMutationVariables> {
    document = UpdateDishTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDishTemplateDocument = gql`
    mutation DeleteDishTemplate($id: Long!, $restaurantId: Long!) {
  deleteDishTemplate(dishTemplateId: $id, restaurantId: $restaurantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDishTemplateGQL extends Apollo.Mutation<DeleteDishTemplateMutation, DeleteDishTemplateMutationVariables> {
    document = DeleteDishTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddMenuEntryDocument = gql`
    mutation AddMenuEntry($menuEntry: RestaurantMenuEntryInput, $menuId: Long, $menuStartDay: DateTime, $menuEndDay: DateTime, $restaurantId: Long!, $addAsTemplate: Boolean!) {
  addRestaurantMenuEntry(
    entry: $menuEntry
    menuId: $menuId
    menuStartDay: $menuStartDay
    menuEndDay: $menuEndDay
    restaurantId: $restaurantId
    addAsTemplate: $addAsTemplate
  ) {
    ...RestaurantMenuEntry
  }
}
    ${RestaurantMenuEntryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddMenuEntryGQL extends Apollo.Mutation<AddMenuEntryMutation, AddMenuEntryMutationVariables> {
    document = AddMenuEntryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMenuEntryDocument = gql`
    mutation UpdateMenuEntry($menuEntry: RestaurantMenuEntryInput, $restaurantId: Long!) {
  updateRestaurantMenuEntry(entry: $menuEntry, restaurantId: $restaurantId) {
    ...RestaurantMenuEntry
  }
}
    ${RestaurantMenuEntryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMenuEntryGQL extends Apollo.Mutation<UpdateMenuEntryMutation, UpdateMenuEntryMutationVariables> {
    document = UpdateMenuEntryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMenuEntryDocument = gql`
    mutation DeleteMenuEntry($id: Long!, $restaurantId: Long!) {
  deleteRestaurantMenuEntry(menuEntryId: $id, restaurantId: $restaurantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMenuEntryGQL extends Apollo.Mutation<DeleteMenuEntryMutation, DeleteMenuEntryMutationVariables> {
    document = DeleteMenuEntryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleHideMenuEntryDocument = gql`
    mutation ToggleHideMenuEntry($id: Long!, $restaurantId: Long!) {
  toggleHideRestaurantMenuEntry(menuEntryId: $id, restaurantId: $restaurantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleHideMenuEntryGQL extends Apollo.Mutation<ToggleHideMenuEntryMutation, ToggleHideMenuEntryMutationVariables> {
    document = ToggleHideMenuEntryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyLastWeekMenuDocument = gql`
    mutation CopyLastWeekMenu($menuStartDay: DateTime!, $menuEndDay: DateTime!, $restaurantId: Long!) {
  copyLastWeekMenu(
    menuStartDay: $menuStartDay
    menuEndDay: $menuEndDay
    restaurantId: $restaurantId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyLastWeekMenuGQL extends Apollo.Mutation<CopyLastWeekMenuMutation, CopyLastWeekMenuMutationVariables> {
    document = CopyLastWeekMenuDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopySelectedWeekMenuDocument = gql`
    mutation CopySelectedWeekMenu($sourceMenuStartDay: DateTime!, $sourceMenuEndDay: DateTime!, $destMenuStartDay: DateTime!, $destMenuEndDay: DateTime!, $restaurantId: Long!) {
  copySelectedWeekMenu(
    sourceMenuStartDay: $sourceMenuStartDay
    sourceMenuEndDay: $sourceMenuEndDay
    destMenuStartDay: $destMenuStartDay
    destMenuEndDay: $destMenuEndDay
    restaurantId: $restaurantId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopySelectedWeekMenuGQL extends Apollo.Mutation<CopySelectedWeekMenuMutation, CopySelectedWeekMenuMutationVariables> {
    document = CopySelectedWeekMenuDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompanyDocument = gql`
    mutation CreateCompany($company: AdminCompanyInput) {
  createCompany(company: $company) {
    ...AdminCompany
  }
}
    ${AdminCompanyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompanyGQL extends Apollo.Mutation<CreateCompanyMutation, CreateCompanyMutationVariables> {
    document = CreateCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($company: AdminCompanyInput) {
  updateCompany(company: $company) {
    ...AdminCompany
  }
}
    ${AdminCompanyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyGQL extends Apollo.Mutation<UpdateCompanyMutation, UpdateCompanyMutationVariables> {
    document = UpdateCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($companyId: Long!) {
  deleteCompany(companyId: $companyId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyGQL extends Apollo.Mutation<DeleteCompanyMutation, DeleteCompanyMutationVariables> {
    document = DeleteCompanyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCompanyOwnerDocument = gql`
    mutation CreateCompanyOwner($companyOwner: AdminCompanyOwnerInput, $password: String, $passwordRepeat: String, $companyId: Long!) {
  createCompanyOwner(
    companyOwner: $companyOwner
    password: $password
    passwordRepeat: $passwordRepeat
    companyId: $companyId
  ) {
    ...AdminCompanyOwner
  }
}
    ${AdminCompanyOwnerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCompanyOwnerGQL extends Apollo.Mutation<CreateCompanyOwnerMutation, CreateCompanyOwnerMutationVariables> {
    document = CreateCompanyOwnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCompanyOwnerDocument = gql`
    mutation UpdateCompanyOwner($companyOwner: AdminCompanyOwnerInput, $password: String, $passwordRepeat: String) {
  updateCompanyOwner(
    companyOwner: $companyOwner
    password: $password
    passwordRepeat: $passwordRepeat
  ) {
    ...AdminCompanyOwner
  }
}
    ${AdminCompanyOwnerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCompanyOwnerGQL extends Apollo.Mutation<UpdateCompanyOwnerMutation, UpdateCompanyOwnerMutationVariables> {
    document = UpdateCompanyOwnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCompanyOwnerDocument = gql`
    mutation DeleteCompanyOwner($ownerId: Long!) {
  deleteCompanyOwner(ownerId: $ownerId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyOwnerGQL extends Apollo.Mutation<DeleteCompanyOwnerMutation, DeleteCompanyOwnerMutationVariables> {
    document = DeleteCompanyOwnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRestaurantDocument = gql`
    mutation CreateRestaurant($restaurant: SuperAdminRestaurantInput) {
  createRestaurant(restaurant: $restaurant) {
    ...SuperAdminRestaurant
  }
}
    ${SuperAdminRestaurantFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRestaurantGQL extends Apollo.Mutation<CreateRestaurantMutation, CreateRestaurantMutationVariables> {
    document = CreateRestaurantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRestaurantDocument = gql`
    mutation UpdateRestaurant($restaurant: SuperAdminRestaurantInput) {
  updateRestaurant(restaurant: $restaurant) {
    ...SuperAdminRestaurant
  }
}
    ${SuperAdminRestaurantFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRestaurantGQL extends Apollo.Mutation<UpdateRestaurantMutation, UpdateRestaurantMutationVariables> {
    document = UpdateRestaurantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRestaurantDocument = gql`
    mutation DeleteRestaurant($restaurantId: Long!) {
  deleteRestaurant(restaurantId: $restaurantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRestaurantGQL extends Apollo.Mutation<DeleteRestaurantMutation, DeleteRestaurantMutationVariables> {
    document = DeleteRestaurantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRestaurantOwnerDocument = gql`
    mutation CreateRestaurantOwner($restaurantOwner: AdminRestaurantOwnerInput, $password: String, $passwordRepeat: String, $restaurantId: Long!) {
  createRestaurantOwner(
    restaurantOwner: $restaurantOwner
    password: $password
    passwordRepeat: $passwordRepeat
    restaurantId: $restaurantId
  ) {
    ...AdminRestaurantOwner
  }
}
    ${AdminRestaurantOwnerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRestaurantOwnerGQL extends Apollo.Mutation<CreateRestaurantOwnerMutation, CreateRestaurantOwnerMutationVariables> {
    document = CreateRestaurantOwnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRestaurantOwnerDocument = gql`
    mutation UpdateRestaurantOwner($restaurantOwner: AdminRestaurantOwnerInput, $password: String, $passwordRepeat: String) {
  updateRestaurantOwner(
    restaurantOwner: $restaurantOwner
    password: $password
    passwordRepeat: $passwordRepeat
  ) {
    ...AdminRestaurantOwner
  }
}
    ${AdminRestaurantOwnerFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRestaurantOwnerGQL extends Apollo.Mutation<UpdateRestaurantOwnerMutation, UpdateRestaurantOwnerMutationVariables> {
    document = UpdateRestaurantOwnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRestaurantOwnerDocument = gql`
    mutation DeleteRestaurantOwner($ownerId: Long!) {
  deleteRestaurantOwner(ownerId: $ownerId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRestaurantOwnerGQL extends Apollo.Mutation<DeleteRestaurantOwnerMutation, DeleteRestaurantOwnerMutationVariables> {
    document = DeleteRestaurantOwnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCompanyToRestaurantDocument = gql`
    mutation AddCompanyToRestaurant($companyId: Long!, $restaurantId: Long!) {
  addCompanyToRestaurant(companyId: $companyId, restaurantId: $restaurantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCompanyToRestaurantGQL extends Apollo.Mutation<AddCompanyToRestaurantMutation, AddCompanyToRestaurantMutationVariables> {
    document = AddCompanyToRestaurantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCompanyFromRestaurantDocument = gql`
    mutation RemoveCompanyFromRestaurant($companyId: Long!, $restaurantId: Long!) {
  removeCompanyFromRestaurant(companyId: $companyId, restaurantId: $restaurantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCompanyFromRestaurantGQL extends Apollo.Mutation<RemoveCompanyFromRestaurantMutation, RemoveCompanyFromRestaurantMutationVariables> {
    document = RemoveCompanyFromRestaurantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRestaurantCompanyTimeslotDocument = gql`
    mutation CreateRestaurantCompanyTimeslot($deliveryLocationTimeSlot: AdminDeliveryLocationTimeSlotInput, $companyDeliveryLocationId: Long!, $restaurantId: Long!) {
  createRestaurantCompanyTimeslot(
    deliveryLocationTimeSlot: $deliveryLocationTimeSlot
    companyDeliveryLocationId: $companyDeliveryLocationId
    restaurantId: $restaurantId
  ) {
    ...AdminDeliveryLocationTimeSlot
  }
}
    ${AdminDeliveryLocationTimeSlotFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRestaurantCompanyTimeslotGQL extends Apollo.Mutation<CreateRestaurantCompanyTimeslotMutation, CreateRestaurantCompanyTimeslotMutationVariables> {
    document = CreateRestaurantCompanyTimeslotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditRestaurantCompanyTimeslotDocument = gql`
    mutation EditRestaurantCompanyTimeslot($deliveryLocationTimeSlot: AdminDeliveryLocationTimeSlotInput) {
  editRestaurantCompanyTimeslot(
    deliveryLocationTimeSlot: $deliveryLocationTimeSlot
  ) {
    ...AdminDeliveryLocationTimeSlot
  }
}
    ${AdminDeliveryLocationTimeSlotFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditRestaurantCompanyTimeslotGQL extends Apollo.Mutation<EditRestaurantCompanyTimeslotMutation, EditRestaurantCompanyTimeslotMutationVariables> {
    document = EditRestaurantCompanyTimeslotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRestaurantCompanyTimeslotDocument = gql`
    mutation DeleteRestaurantCompanyTimeslot($timeslotId: Long!) {
  deleteRestaurantCompanyTimeslot(timeslotId: $timeslotId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRestaurantCompanyTimeslotGQL extends Apollo.Mutation<DeleteRestaurantCompanyTimeslotMutation, DeleteRestaurantCompanyTimeslotMutationVariables> {
    document = DeleteRestaurantCompanyTimeslotDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDeliveryLocationDocument = gql`
    mutation CreateDeliveryLocation($deliveryLocation: CompanyDeliveryLocationInput, $companyId: Long!) {
  createDeliveryLocation(
    deliveryLocation: $deliveryLocation
    companyId: $companyId
  ) {
    ...CompanyDeliveryLocation
  }
}
    ${CompanyDeliveryLocationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDeliveryLocationGQL extends Apollo.Mutation<CreateDeliveryLocationMutation, CreateDeliveryLocationMutationVariables> {
    document = CreateDeliveryLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDeliveryLocationDocument = gql`
    mutation UpdateDeliveryLocation($deliveryLocation: CompanyDeliveryLocationInput) {
  updateDeliveryLocation(deliveryLocation: $deliveryLocation) {
    ...CompanyDeliveryLocation
  }
}
    ${CompanyDeliveryLocationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDeliveryLocationGQL extends Apollo.Mutation<UpdateDeliveryLocationMutation, UpdateDeliveryLocationMutationVariables> {
    document = UpdateDeliveryLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DelteDeliveryLocationDocument = gql`
    mutation DelteDeliveryLocation($deliveryLocationId: Long!) {
  deleteDeliveryLocation(deliveryLocationId: $deliveryLocationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DelteDeliveryLocationGQL extends Apollo.Mutation<DelteDeliveryLocationMutation, DelteDeliveryLocationMutationVariables> {
    document = DelteDeliveryLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMenuCategoryDocument = gql`
    mutation UpdateMenuCategory($menuCategory: RestaurantMenuCategoryInput) {
  updateMenuCategory(menuCategory: $menuCategory) {
    ...RestaurantMenuCategory
  }
}
    ${RestaurantMenuCategoryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMenuCategoryGQL extends Apollo.Mutation<UpdateMenuCategoryMutation, UpdateMenuCategoryMutationVariables> {
    document = UpdateMenuCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMenuCategoryDocument = gql`
    mutation CreateMenuCategory($menuCategory: RestaurantMenuCategoryInput) {
  createMenuCategory(menuCategory: $menuCategory) {
    ...RestaurantMenuCategory
  }
}
    ${RestaurantMenuCategoryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMenuCategoryGQL extends Apollo.Mutation<CreateMenuCategoryMutation, CreateMenuCategoryMutationVariables> {
    document = CreateMenuCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMenuCategoryDocument = gql`
    mutation DeleteMenuCategory($id: Long!) {
  deleteMenuCategory(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMenuCategoryGQL extends Apollo.Mutation<DeleteMenuCategoryMutation, DeleteMenuCategoryMutationVariables> {
    document = DeleteMenuCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDishAllergenDocument = gql`
    mutation UpdateDishAllergen($dishAllergen: DishAllergeneInput) {
  updateDishAllergen(dishAllergen: $dishAllergen) {
    ...DishAllergene
  }
}
    ${DishAllergeneFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDishAllergenGQL extends Apollo.Mutation<UpdateDishAllergenMutation, UpdateDishAllergenMutationVariables> {
    document = UpdateDishAllergenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDishAllergenDocument = gql`
    mutation CreateDishAllergen($dishAllergen: DishAllergeneInput) {
  createDishAllergen(dishAllergen: $dishAllergen) {
    ...DishAllergene
  }
}
    ${DishAllergeneFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDishAllergenGQL extends Apollo.Mutation<CreateDishAllergenMutation, CreateDishAllergenMutationVariables> {
    document = CreateDishAllergenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDishAllergenDocument = gql`
    mutation DeleteDishAllergen($id: Long!) {
  deleteDishAllergen(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDishAllergenGQL extends Apollo.Mutation<DeleteDishAllergenMutation, DeleteDishAllergenMutationVariables> {
    document = DeleteDishAllergenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($username: String, $password: String) {
  updateUser(loginData: {username: $username, password: $password}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConsumePasswordResetTokenDocument = gql`
    mutation ConsumePasswordResetToken($email: String, $token: String, $newPassword: String) {
  consumePasswordResetToken(
    email: $email
    token: $token
    newPassword: $newPassword
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConsumePasswordResetTokenGQL extends Apollo.Mutation<ConsumePasswordResetTokenMutation, ConsumePasswordResetTokenMutationVariables> {
    document = ConsumePasswordResetTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    query Login($username: String, $password: String) {
  login(loginData: {username: $username, password: $password}) {
    id
    accessToken
    refreshToken
    accessTokenExpirationDate
    refreshTokenExpirationDate
    roles
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Query<LoginQuery, LoginQueryVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshAccessTokenDocument = gql`
    query RefreshAccessToken($refreshToken: String) {
  refreshAccessToken(refreshToken: $refreshToken) {
    id
    accessToken
    refreshToken
    accessTokenExpirationDate
    refreshTokenExpirationDate
    roles
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshAccessTokenGQL extends Apollo.Query<RefreshAccessTokenQuery, RefreshAccessTokenQueryVariables> {
    document = RefreshAccessTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrenciesDocument = gql`
    query GetCurrencies {
  currencies {
    ...Currency
  }
}
    ${CurrencyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrenciesGQL extends Apollo.Query<GetCurrenciesQuery, GetCurrenciesQueryVariables> {
    document = GetCurrenciesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDefaultCompanyWithDetailsDocument = gql`
    query GetDefaultCompanyWithDetails {
  defaultCompanyWithDetails {
    ...AdminCompany
  }
}
    ${AdminCompanyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultCompanyWithDetailsGQL extends Apollo.Query<GetDefaultCompanyWithDetailsQuery, GetDefaultCompanyWithDetailsQueryVariables> {
    document = GetDefaultCompanyWithDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyOrdersStatisticsDocument = gql`
    query GetCompanyOrdersStatistics($companyId: Long!, $startDate: DateTime!, $endDate: DateTime!) {
  companyOrdersStatistics(
    companyId: $companyId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...CompanyOrdersStatistics
  }
}
    ${CompanyOrdersStatisticsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyOrdersStatisticsGQL extends Apollo.Query<GetCompanyOrdersStatisticsQuery, GetCompanyOrdersStatisticsQueryVariables> {
    document = GetCompanyOrdersStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyEmployeesWithoutOrdersDocument = gql`
    query GetCompanyEmployeesWithoutOrders($companyId: Long!) {
  companyEmployeesWithoutOrders(companyId: $companyId) {
    ...CompanyEmployeeWithSubsidyAmount
  }
}
    ${CompanyEmployeeWithSubsidyAmountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyEmployeesWithoutOrdersGQL extends Apollo.Query<GetCompanyEmployeesWithoutOrdersQuery, GetCompanyEmployeesWithoutOrdersQueryVariables> {
    document = GetCompanyEmployeesWithoutOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyBasicStatsDocument = gql`
    query GetCompanyBasicStats($companyId: Long!) {
  companyBasicStats(companyId: $companyId) {
    ...CompanyBasicStats
  }
}
    ${CompanyBasicStatsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyBasicStatsGQL extends Apollo.Query<GetCompanyBasicStatsQuery, GetCompanyBasicStatsQueryVariables> {
    document = GetCompanyBasicStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyRestaurantsDocument = gql`
    query GetCompanyRestaurants($companyId: Long!) {
  companyRestaurants(companyId: $companyId) {
    ...RestaurantWithStats
  }
}
    ${RestaurantWithStatsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyRestaurantsGQL extends Apollo.Query<GetCompanyRestaurantsQuery, GetCompanyRestaurantsQueryVariables> {
    document = GetCompanyRestaurantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRestaurantOrdersStatisticsDocument = gql`
    query GetRestaurantOrdersStatistics($companyId: Long!, $restaurantId: Long!, $startDate: DateTime!, $endDate: DateTime!) {
  restaurantOrdersStatistics(
    companyId: $companyId
    restaurantId: $restaurantId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...RestaurantOrdersStatistics
  }
}
    ${RestaurantOrdersStatisticsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRestaurantOrdersStatisticsGQL extends Apollo.Query<GetRestaurantOrdersStatisticsQuery, GetRestaurantOrdersStatisticsQueryVariables> {
    document = GetRestaurantOrdersStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyAllEmployeesDocument = gql`
    query GetCompanyAllEmployees($companyId: Long!) {
  companyAllEmployees(companyId: $companyId) {
    ...CompanyEmployeeWithSubsidyAmount
  }
}
    ${CompanyEmployeeWithSubsidyAmountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyAllEmployeesGQL extends Apollo.Query<GetCompanyAllEmployeesQuery, GetCompanyAllEmployeesQueryVariables> {
    document = GetCompanyAllEmployeesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeOrdersStatisticsDocument = gql`
    query GetEmployeeOrdersStatistics($companyId: Long!, $employeeId: Long!, $startDate: DateTime!, $endDate: DateTime!) {
  employeeOrdersStatistics(
    companyId: $companyId
    employeeId: $employeeId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...EmployeeOrdersStatistics
  }
}
    ${EmployeeOrdersStatisticsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeOrdersStatisticsGQL extends Apollo.Query<GetEmployeeOrdersStatisticsQuery, GetEmployeeOrdersStatisticsQueryVariables> {
    document = GetEmployeeOrdersStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCompanyEmployeesGroupsDocument = gql`
    query GetCompanyEmployeesGroups($companyId: Long!) {
  companyEmployeesGroups(companyId: $companyId) {
    ...CompanyEmployeeGroup
  }
}
    ${CompanyEmployeeGroupFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCompanyEmployeesGroupsGQL extends Apollo.Query<GetCompanyEmployeesGroupsQuery, GetCompanyEmployeesGroupsQueryVariables> {
    document = GetCompanyEmployeesGroupsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeGroupOrdersStatisticsDocument = gql`
    query GetEmployeeGroupOrdersStatistics($companyId: Long!, $groupId: Long!, $startDate: DateTime!, $endDate: DateTime!) {
  employeeGroupOrdersStatistics(
    companyId: $companyId
    groupId: $groupId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...EmployeeGroupOrdersStatistics
  }
}
    ${EmployeeGroupOrdersStatisticsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeGroupOrdersStatisticsGQL extends Apollo.Query<GetEmployeeGroupOrdersStatisticsQuery, GetEmployeeGroupOrdersStatisticsQueryVariables> {
    document = GetEmployeeGroupOrdersStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDefaultAdminRestaurantWithDetailsDocument = gql`
    query GetDefaultAdminRestaurantWithDetails {
  defaultRestaurantWithDetails {
    id
    details {
      id
      name
      imageUrl
    }
    companies {
      id
      details {
        language {
          code
        }
        name
      }
    }
    deliveryLocations {
      id
      timeSlots {
        id
        time
        hour
        minute
      }
      details {
        id
        name
        language {
          code
        }
      }
      lat
      lon
    }
    settings {
      id
      defaultDishOfTheDayPrice
      testMode
      provisionPercentage
      provisionForCompanyPercentage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultAdminRestaurantWithDetailsGQL extends Apollo.Query<GetDefaultAdminRestaurantWithDetailsQuery, GetDefaultAdminRestaurantWithDetailsQueryVariables> {
    document = GetDefaultAdminRestaurantWithDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetHistoricalRestaurantOrdersDocument = gql`
    query GetHistoricalRestaurantOrders($startDateTime: DateTime!, $endDateTime: DateTime!, $deliveryLocationIds: [Long!], $companyIds: [Long!], $restaurantId: Long!) {
  restaurantOrders(
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    deliveryLocationIds: $deliveryLocationIds
    companyIds: $companyIds
    restaurantId: $restaurantId
  ) {
    ...EmployeeOrderForTable
  }
}
    ${EmployeeOrderForTableFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHistoricalRestaurantOrdersGQL extends Apollo.Query<GetHistoricalRestaurantOrdersQuery, GetHistoricalRestaurantOrdersQueryVariables> {
    document = GetHistoricalRestaurantOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentRestaurantOrdersDocument = gql`
    query GetCurrentRestaurantOrders($startDateTime: DateTime!, $endDateTime: DateTime!, $deliveryLocationIds: [Long!], $companyIds: [Long!], $restaurantId: Long!) {
  currentRestaurantOrders(
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    deliveryLocationIds: $deliveryLocationIds
    companyIds: $companyIds
    restaurantId: $restaurantId
  ) {
    ...RestaurantCurrentOrder
  }
}
    ${RestaurantCurrentOrderFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentRestaurantOrdersGQL extends Apollo.Query<GetCurrentRestaurantOrdersQuery, GetCurrentRestaurantOrdersQueryVariables> {
    document = GetCurrentRestaurantOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRestaurantDishTemplatesDocument = gql`
    query GetRestaurantDishTemplates($restaurantId: Long!) {
  allDishTemplates(restaurantId: $restaurantId) {
    ...RestaurantDishTemplate
  }
}
    ${RestaurantDishTemplateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRestaurantDishTemplatesGQL extends Apollo.Query<GetRestaurantDishTemplatesQuery, GetRestaurantDishTemplatesQueryVariables> {
    document = GetRestaurantDishTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRestaurantMenuDocument = gql`
    query GetRestaurantMenu($dayInWeek: DateTime!, $restaurantId: Long!) {
  menuForWeek(dayInWeek: $dayInWeek, restaurantId: $restaurantId) {
    ...RestaurantMenu
  }
}
    ${RestaurantMenuFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRestaurantMenuGQL extends Apollo.Query<GetRestaurantMenuQuery, GetRestaurantMenuQueryVariables> {
    document = GetRestaurantMenuDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDishAllergensDocument = gql`
    query GetDishAllergens {
  dishAllergens {
    id
    details {
      id
      name
      language {
        code
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDishAllergensGQL extends Apollo.Query<GetDishAllergensQuery, GetDishAllergensQueryVariables> {
    document = GetDishAllergensDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMenuCategoriesDocument = gql`
    query GetMenuCategories {
  menuCattegories {
    id
    details {
      id
      categoryName
      language {
        code
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMenuCategoriesGQL extends Apollo.Query<GetMenuCategoriesQuery, GetMenuCategoriesQueryVariables> {
    document = GetMenuCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBasicSettlementStatsDocument = gql`
    query GetBasicSettlementStats($restaurantId: Long!) {
  basicSettlementStats(restaurantId: $restaurantId) {
    ...RestaurantBasicSettlementAmount
  }
}
    ${RestaurantBasicSettlementAmountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBasicSettlementStatsGQL extends Apollo.Query<GetBasicSettlementStatsQuery, GetBasicSettlementStatsQueryVariables> {
    document = GetBasicSettlementStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrdersStatsDocument = gql`
    query GetOrdersStats($start: DateTime!, $end: DateTime!, $restaurantId: Long!) {
  ordersStats(start: $start, end: $end, restaurantId: $restaurantId) {
    ...RestaurantDeliveryCount
  }
}
    ${RestaurantDeliveryCountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrdersStatsGQL extends Apollo.Query<GetOrdersStatsQuery, GetOrdersStatsQueryVariables> {
    document = GetOrdersStatsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRestaurantInvoicesDocument = gql`
    query GetRestaurantInvoices($restaurantId: Long!) {
  restaurantInvoices(restaurantId: $restaurantId) {
    ...RestaurantInvoice
  }
}
    ${RestaurantInvoiceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRestaurantInvoicesGQL extends Apollo.Query<GetRestaurantInvoicesQuery, GetRestaurantInvoicesQueryVariables> {
    document = GetRestaurantInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRestaurantFinishedOrdersStatisticsDocument = gql`
    query GetRestaurantFinishedOrdersStatistics($restaurantId: Long!, $companyId: Long, $startDate: DateTime!, $endDate: DateTime!) {
  restaurantFinishedOrdersStatistics(
    restaurantId: $restaurantId
    companyId: $companyId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...RestaurantFinishedOrdersStatistics
  }
}
    ${RestaurantFinishedOrdersStatisticsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRestaurantFinishedOrdersStatisticsGQL extends Apollo.Query<GetRestaurantFinishedOrdersStatisticsQuery, GetRestaurantFinishedOrdersStatisticsQueryVariables> {
    document = GetRestaurantFinishedOrdersStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRestaurantCompaniesDocument = gql`
    query GetRestaurantCompanies($restaurantId: Long!) {
  restaurantCompanies(restaurantId: $restaurantId) {
    ...RestaurantCompaniesWithStats
  }
}
    ${RestaurantCompaniesWithStatsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRestaurantCompaniesGQL extends Apollo.Query<GetRestaurantCompaniesQuery, GetRestaurantCompaniesQueryVariables> {
    document = GetRestaurantCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRestaurantCompanyOrdersStatisticsDocument = gql`
    query GetRestaurantCompanyOrdersStatistics($companyId: Long!, $restaurantId: Long!, $startDate: DateTime!, $endDate: DateTime!) {
  restaurantCompanyOrdersStatistics(
    companyId: $companyId
    restaurantId: $restaurantId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...CompanyOrdersStatistics
  }
}
    ${CompanyOrdersStatisticsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRestaurantCompanyOrdersStatisticsGQL extends Apollo.Query<GetRestaurantCompanyOrdersStatisticsQuery, GetRestaurantCompanyOrdersStatisticsQueryVariables> {
    document = GetRestaurantCompanyOrdersStatisticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRestaurantComplaintsDocument = gql`
    query GetRestaurantComplaints($restaurantId: Long!, $startDate: DateTime!, $endDate: DateTime!) {
  restaurantComplaints(
    restaurantId: $restaurantId
    start: $startDate
    end: $endDate
  ) {
    ...EmpioyeeOrderComplaintForList
  }
}
    ${EmpioyeeOrderComplaintForListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRestaurantComplaintsGQL extends Apollo.Query<GetRestaurantComplaintsQuery, GetRestaurantComplaintsQueryVariables> {
    document = GetRestaurantComplaintsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAdminCompaniesDocument = gql`
    query GetAdminCompanies {
  adminCompanies {
    ...SuperAdminCompany
  }
}
    ${SuperAdminCompanyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAdminCompaniesGQL extends Apollo.Query<GetAdminCompaniesQuery, GetAdminCompaniesQueryVariables> {
    document = GetAdminCompaniesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAdminRestaurantsDocument = gql`
    query GetAdminRestaurants {
  adminRestaurants {
    ...SuperAdminRestaurant
  }
}
    ${SuperAdminRestaurantFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAdminRestaurantsGQL extends Apollo.Query<GetAdminRestaurantsQuery, GetAdminRestaurantsQueryVariables> {
    document = GetAdminRestaurantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }